var items = {
  "block.minecraft.acacia_button": "Botão de Acácia",
  "block.minecraft.acacia_door": "Porta de Acácia",
  "block.minecraft.acacia_fence": "Cerca de Acácia",
  "block.minecraft.acacia_fence_gate": "Portão de Acácia",
  "block.minecraft.acacia_hanging_sign": "Placa Suspensa de Acácia",
  "block.minecraft.acacia_leaves": "Folhas de Acácia",
  "block.minecraft.acacia_log": "Tronco de Acácia",
  "block.minecraft.acacia_planks": "Tábuas de Acácia",
  "block.minecraft.acacia_pressure_plate": "Placa de Pressão de Acácia",
  "block.minecraft.acacia_sapling": "Muda de Acácia",
  "block.minecraft.acacia_shelf": "Estante de Acácia",
  "block.minecraft.acacia_sign": "Placa de Acácia",
  "block.minecraft.acacia_slab": "Laje de Acácia",
  "block.minecraft.acacia_stairs": "Escadas de Acácia",
  "block.minecraft.acacia_trapdoor": "Alçapão de Acácia",
  "block.minecraft.acacia_wall_hanging_sign": "Placa Suspensa de Acácia de Parede",
  "block.minecraft.acacia_wall_sign": "Placa de Acácia de Parede",
  "block.minecraft.acacia_wood": "Madeira de Acácia",
  "block.minecraft.activator_rail": "Trilho Ativador",
  "block.minecraft.air": "Ar",
  "block.minecraft.allium": "Alho-Silvestre",
  "block.minecraft.amethyst_block": "Bloco de Ametista",
  "block.minecraft.amethyst_cluster": "Agregado de Ametista",
  "block.minecraft.ancient_debris": "Detritos Ancestrais",
  "block.minecraft.andesite": "Andesito",
  "block.minecraft.andesite_slab": "Laje de Andesito",
  "block.minecraft.andesite_stairs": "Escadas de Andesito",
  "block.minecraft.andesite_wall": "Muro de Andesito",
  "block.minecraft.anvil": "Bigorna",
  "block.minecraft.attached_melon_stem": "Caule de Melancia Unido",
  "block.minecraft.attached_pumpkin_stem": "Caule de Abóbora Unido",
  "block.minecraft.azalea": "Azaleia",
  "block.minecraft.azalea_leaves": "Folhas de Azaleia",
  "block.minecraft.azure_bluet": "Flor-Silvestre-Azul",
  "block.minecraft.bamboo": "Bambu",
  "block.minecraft.bamboo_block": "Bloco de Bambu",
  "block.minecraft.bamboo_button": "Botão de Bambu",
  "block.minecraft.bamboo_door": "Porta de Bambu",
  "block.minecraft.bamboo_fence": "Cerca de Bambu",
  "block.minecraft.bamboo_fence_gate": "Portão de Bambu",
  "block.minecraft.bamboo_hanging_sign": "Placa Suspensa de Bambu",
  "block.minecraft.bamboo_mosaic": "Mosaico de Bambu",
  "block.minecraft.bamboo_mosaic_slab": "Laje de Mosaico de Bambu",
  "block.minecraft.bamboo_mosaic_stairs": "Escadas de Mosaico de Bambu",
  "block.minecraft.bamboo_planks": "Tábuas de Bambu",
  "block.minecraft.bamboo_pressure_plate": "Placa de Pressão de Bambu",
  "block.minecraft.bamboo_sapling": "Muda de Bambu",
  "block.minecraft.bamboo_shelf": "Estante de Bambu",
  "block.minecraft.bamboo_sign": "Placa de Bambu",
  "block.minecraft.bamboo_slab": "Laje de Bambu",
  "block.minecraft.bamboo_stairs": "Escadas de Bambu",
  "block.minecraft.bamboo_trapdoor": "Alçapão de Bambu",
  "block.minecraft.bamboo_wall_hanging_sign": "Placa Suspensa de Bambu de Parede",
  "block.minecraft.bamboo_wall_sign": "Placa de Bambu de Parede",
  "block.minecraft.banner.base.black": "Campo Preto",
  "block.minecraft.banner.base.blue": "Campo Azul",
  "block.minecraft.banner.base.brown": "Campo Marrom",
  "block.minecraft.banner.base.cyan": "Campo Ciano",
  "block.minecraft.banner.base.gray": "Campo Cinza",
  "block.minecraft.banner.base.green": "Campo Verde",
  "block.minecraft.banner.base.light_blue": "Campo Azul-Claro",
  "block.minecraft.banner.base.light_gray": "Campo Cinza-Claro",
  "block.minecraft.banner.base.lime": "Campo Verde-Limão",
  "block.minecraft.banner.base.magenta": "Campo Magenta",
  "block.minecraft.banner.base.orange": "Campo Laranja",
  "block.minecraft.banner.base.pink": "Campo Rosa",
  "block.minecraft.banner.base.purple": "Campo Roxo",
  "block.minecraft.banner.base.red": "Campo Vermelho",
  "block.minecraft.banner.base.white": "Campo Branco",
  "block.minecraft.banner.base.yellow": "Campo Amarelo",
  "block.minecraft.banner.border.black": "Bordadura Preta",
  "block.minecraft.banner.border.blue": "Bordadura Azul",
  "block.minecraft.banner.border.brown": "Bordadura Marrom",
  "block.minecraft.banner.border.cyan": "Bordadura Ciano",
  "block.minecraft.banner.border.gray": "Bordadura Cinza",
  "block.minecraft.banner.border.green": "Bordadura Verde",
  "block.minecraft.banner.border.light_blue": "Bordadura Azul-Clara",
  "block.minecraft.banner.border.light_gray": "Bordadura Cinza-Clara",
  "block.minecraft.banner.border.lime": "Bordadura Verde-Limão",
  "block.minecraft.banner.border.magenta": "Bordadura Magenta",
  "block.minecraft.banner.border.orange": "Bordadura Laranja",
  "block.minecraft.banner.border.pink": "Bordadura Rosa",
  "block.minecraft.banner.border.purple": "Bordadura Roxa",
  "block.minecraft.banner.border.red": "Bordadura Vermelha",
  "block.minecraft.banner.border.white": "Bordadura Branca",
  "block.minecraft.banner.border.yellow": "Bordadura Amarela",
  "block.minecraft.banner.bricks.black": "Muro Preto",
  "block.minecraft.banner.bricks.blue": "Muro Azul",
  "block.minecraft.banner.bricks.brown": "Muro Marrom",
  "block.minecraft.banner.bricks.cyan": "Muro Ciano",
  "block.minecraft.banner.bricks.gray": "Muro Cinza",
  "block.minecraft.banner.bricks.green": "Muro Verde",
  "block.minecraft.banner.bricks.light_blue": "Muro Azul-Claro",
  "block.minecraft.banner.bricks.light_gray": "Muro Cinza-Claro",
  "block.minecraft.banner.bricks.lime": "Muro Verde-Limão",
  "block.minecraft.banner.bricks.magenta": "Muro Magenta",
  "block.minecraft.banner.bricks.orange": "Muro Laranja",
  "block.minecraft.banner.bricks.pink": "Muro Rosa",
  "block.minecraft.banner.bricks.purple": "Muro Roxo",
  "block.minecraft.banner.bricks.red": "Muro Vermelho",
  "block.minecraft.banner.bricks.white": "Muro Branco",
  "block.minecraft.banner.bricks.yellow": "Muro Amarelo",
  "block.minecraft.banner.circle.black": "Besante Preto",
  "block.minecraft.banner.circle.blue": "Besante Azul",
  "block.minecraft.banner.circle.brown": "Besante Marrom",
  "block.minecraft.banner.circle.cyan": "Besante Ciano",
  "block.minecraft.banner.circle.gray": "Besante Cinza",
  "block.minecraft.banner.circle.green": "Besante Verde",
  "block.minecraft.banner.circle.light_blue": "Besante Azul-Claro",
  "block.minecraft.banner.circle.light_gray": "Besante Cinza-Claro",
  "block.minecraft.banner.circle.lime": "Besante Verde-Limão",
  "block.minecraft.banner.circle.magenta": "Besante Magenta",
  "block.minecraft.banner.circle.orange": "Besante Laranja",
  "block.minecraft.banner.circle.pink": "Besante Rosa",
  "block.minecraft.banner.circle.purple": "Besante Roxo",
  "block.minecraft.banner.circle.red": "Besante Vermelho",
  "block.minecraft.banner.circle.white": "Besante Branco",
  "block.minecraft.banner.circle.yellow": "Besante Amarelo",
  "block.minecraft.banner.creeper.black": "Figura de Creeper Preto",
  "block.minecraft.banner.creeper.blue": "Figura de Creeper Azul",
  "block.minecraft.banner.creeper.brown": "Figura de Creeper Marrom",
  "block.minecraft.banner.creeper.cyan": "Figura de Creeper Ciano",
  "block.minecraft.banner.creeper.gray": "Figura de Creeper Cinza",
  "block.minecraft.banner.creeper.green": "Figura de Creeper Verde",
  "block.minecraft.banner.creeper.light_blue": "Figura de Creeper Azul-Claro",
  "block.minecraft.banner.creeper.light_gray": "Figura de Creeper Cinza-Claro",
  "block.minecraft.banner.creeper.lime": "Figura de Creeper Verde-Limão",
  "block.minecraft.banner.creeper.magenta": "Figura de Creeper Magenta",
  "block.minecraft.banner.creeper.orange": "Figura de Creeper Laranja",
  "block.minecraft.banner.creeper.pink": "Figura de Creeper Rosa",
  "block.minecraft.banner.creeper.purple": "Figura de Creeper Roxo",
  "block.minecraft.banner.creeper.red": "Figura de Creeper Vermelho",
  "block.minecraft.banner.creeper.white": "Figura de Creeper Branco",
  "block.minecraft.banner.creeper.yellow": "Figura de Creeper Amarelo",
  "block.minecraft.banner.cross.black": "Aspa Preta",
  "block.minecraft.banner.cross.blue": "Aspa Azul",
  "block.minecraft.banner.cross.brown": "Aspa Marrom",
  "block.minecraft.banner.cross.cyan": "Aspa Ciano",
  "block.minecraft.banner.cross.gray": "Aspa Cinza",
  "block.minecraft.banner.cross.green": "Aspa Verde",
  "block.minecraft.banner.cross.light_blue": "Aspa Azul-Clara",
  "block.minecraft.banner.cross.light_gray": "Aspa Cinza-Clara",
  "block.minecraft.banner.cross.lime": "Aspa Verde-Limão",
  "block.minecraft.banner.cross.magenta": "Aspa Magenta",
  "block.minecraft.banner.cross.orange": "Aspa Laranja",
  "block.minecraft.banner.cross.pink": "Aspa Rosa",
  "block.minecraft.banner.cross.purple": "Aspa Roxa",
  "block.minecraft.banner.cross.red": "Aspa Vermelha",
  "block.minecraft.banner.cross.white": "Aspa Branca",
  "block.minecraft.banner.cross.yellow": "Aspa Amarela",
  "block.minecraft.banner.curly_border.black": "Bordadura Dentada Preta",
  "block.minecraft.banner.curly_border.blue": "Bordadura Dentada Azul",
  "block.minecraft.banner.curly_border.brown": "Bordadura Dentada Marrom",
  "block.minecraft.banner.curly_border.cyan": "Bordadura Dentada Ciano",
  "block.minecraft.banner.curly_border.gray": "Bordadura Dentada Cinza",
  "block.minecraft.banner.curly_border.green": "Bordadura Dentada Verde",
  "block.minecraft.banner.curly_border.light_blue": "Bordadura Dentada Azul-Clara",
  "block.minecraft.banner.curly_border.light_gray": "Bordadura Dentada Cinza-Clara",
  "block.minecraft.banner.curly_border.lime": "Bordadura Dentada Verde-Limão",
  "block.minecraft.banner.curly_border.magenta": "Bordadura Dentada Magenta",
  "block.minecraft.banner.curly_border.orange": "Bordadura Dentada Laranja",
  "block.minecraft.banner.curly_border.pink": "Bordadura Dentada Rosa",
  "block.minecraft.banner.curly_border.purple": "Bordadura Dentada Roxa",
  "block.minecraft.banner.curly_border.red": "Bordadura Dentada Vermelha",
  "block.minecraft.banner.curly_border.white": "Bordadura Dentada Branca",
  "block.minecraft.banner.curly_border.yellow": "Bordadura Dentada Amarela",
  "block.minecraft.banner.diagonal_left.black": "Talhado Preto",
  "block.minecraft.banner.diagonal_left.blue": "Talhado Azul",
  "block.minecraft.banner.diagonal_left.brown": "Talhado Marrom",
  "block.minecraft.banner.diagonal_left.cyan": "Talhado Ciano",
  "block.minecraft.banner.diagonal_left.gray": "Talhado Cinza",
  "block.minecraft.banner.diagonal_left.green": "Talhado Verde",
  "block.minecraft.banner.diagonal_left.light_blue": "Talhado Azul-Claro",
  "block.minecraft.banner.diagonal_left.light_gray": "Talhado Cinza-Claro",
  "block.minecraft.banner.diagonal_left.lime": "Talhado Verde-Limão",
  "block.minecraft.banner.diagonal_left.magenta": "Talhado Magenta",
  "block.minecraft.banner.diagonal_left.orange": "Talhado Laranja",
  "block.minecraft.banner.diagonal_left.pink": "Talhado Rosa",
  "block.minecraft.banner.diagonal_left.purple": "Talhado Roxo",
  "block.minecraft.banner.diagonal_left.red": "Talhado Vermelho",
  "block.minecraft.banner.diagonal_left.white": "Talhado Branco",
  "block.minecraft.banner.diagonal_left.yellow": "Talhado Amarelo",
  "block.minecraft.banner.diagonal_right.black": "Fendido Preto",
  "block.minecraft.banner.diagonal_right.blue": "Fendido Azul",
  "block.minecraft.banner.diagonal_right.brown": "Fendido Marrom",
  "block.minecraft.banner.diagonal_right.cyan": "Fendido Ciano",
  "block.minecraft.banner.diagonal_right.gray": "Fendido Cinza",
  "block.minecraft.banner.diagonal_right.green": "Fendido Verde",
  "block.minecraft.banner.diagonal_right.light_blue": "Fendido Azul-Claro",
  "block.minecraft.banner.diagonal_right.light_gray": "Fendido Cinza-Claro",
  "block.minecraft.banner.diagonal_right.lime": "Fendido Verde-Limão",
  "block.minecraft.banner.diagonal_right.magenta": "Fendido Magenta",
  "block.minecraft.banner.diagonal_right.orange": "Fendido Laranja",
  "block.minecraft.banner.diagonal_right.pink": "Fendido Rosa",
  "block.minecraft.banner.diagonal_right.purple": "Fendido Roxo",
  "block.minecraft.banner.diagonal_right.red": "Fendido Vermelho",
  "block.minecraft.banner.diagonal_right.white": "Fendido Branco",
  "block.minecraft.banner.diagonal_right.yellow": "Fendido Amarelo",
  "block.minecraft.banner.diagonal_up_left.black": "Fendido Preto Invertido",
  "block.minecraft.banner.diagonal_up_left.blue": "Fendido Azul Invertido",
  "block.minecraft.banner.diagonal_up_left.brown": "Fendido Marrom Invertido",
  "block.minecraft.banner.diagonal_up_left.cyan": "Fendido Ciano Invertido",
  "block.minecraft.banner.diagonal_up_left.gray": "Fendido Cinza Invertido",
  "block.minecraft.banner.diagonal_up_left.green": "Fendido Verde Invertido",
  "block.minecraft.banner.diagonal_up_left.light_blue": "Fendido Azul-Claro Invertido",
  "block.minecraft.banner.diagonal_up_left.light_gray": "Fendido Cinza-Claro Invertido",
  "block.minecraft.banner.diagonal_up_left.lime": "Fendido Verde-Limão Invertido",
  "block.minecraft.banner.diagonal_up_left.magenta": "Fendido Magenta Invertido",
  "block.minecraft.banner.diagonal_up_left.orange": "Fendido Laranja Invertido",
  "block.minecraft.banner.diagonal_up_left.pink": "Fendido Rosa Invertido",
  "block.minecraft.banner.diagonal_up_left.purple": "Fendido Roxo Invertido",
  "block.minecraft.banner.diagonal_up_left.red": "Fendido Vermelho Invertido",
  "block.minecraft.banner.diagonal_up_left.white": "Fendido Branco Invertido",
  "block.minecraft.banner.diagonal_up_left.yellow": "Fendido Amarelo Invertido",
  "block.minecraft.banner.diagonal_up_right.black": "Talhado Preto Invertido",
  "block.minecraft.banner.diagonal_up_right.blue": "Talhado Azul Invertido",
  "block.minecraft.banner.diagonal_up_right.brown": "Talhado Marrom Invertido",
  "block.minecraft.banner.diagonal_up_right.cyan": "Talhado Ciano Invertido",
  "block.minecraft.banner.diagonal_up_right.gray": "Talhado Cinza Invertido",
  "block.minecraft.banner.diagonal_up_right.green": "Talhado Verde Invertido",
  "block.minecraft.banner.diagonal_up_right.light_blue": "Talhado Azul-Claro Invertido",
  "block.minecraft.banner.diagonal_up_right.light_gray": "Talhado Cinza-Claro Invertido",
  "block.minecraft.banner.diagonal_up_right.lime": "Talhado Verde-Limão Invertido",
  "block.minecraft.banner.diagonal_up_right.magenta": "Talhado Magenta Invertido",
  "block.minecraft.banner.diagonal_up_right.orange": "Talhado Laranja Invertido",
  "block.minecraft.banner.diagonal_up_right.pink": "Talhado Rosa Invertido",
  "block.minecraft.banner.diagonal_up_right.purple": "Talhado Roxo Invertido",
  "block.minecraft.banner.diagonal_up_right.red": "Talhado Vermelho Invertido",
  "block.minecraft.banner.diagonal_up_right.white": "Talhado Branco Invertido",
  "block.minecraft.banner.diagonal_up_right.yellow": "Talhado Amarelo Invertido",
  "block.minecraft.banner.flow.black": "Espiral Preta",
  "block.minecraft.banner.flow.blue": "Espiral Azul",
  "block.minecraft.banner.flow.brown": "Espiral Marrom",
  "block.minecraft.banner.flow.cyan": "Espiral Ciano",
  "block.minecraft.banner.flow.gray": "Espiral Cinza",
  "block.minecraft.banner.flow.green": "Espiral Verde",
  "block.minecraft.banner.flow.light_blue": "Espiral Azul-Clara",
  "block.minecraft.banner.flow.light_gray": "Espiral Cinza-Clara",
  "block.minecraft.banner.flow.lime": "Espiral Verde-Limão",
  "block.minecraft.banner.flow.magenta": "Espiral Magenta",
  "block.minecraft.banner.flow.orange": "Espiral Laranja",
  "block.minecraft.banner.flow.pink": "Espiral Rosa",
  "block.minecraft.banner.flow.purple": "Espiral Roxa",
  "block.minecraft.banner.flow.red": "Espiral Vermelha",
  "block.minecraft.banner.flow.white": "Espiral Branca",
  "block.minecraft.banner.flow.yellow": "Espiral Amarela",
  "block.minecraft.banner.flower.black": "Figura Preta de Flor",
  "block.minecraft.banner.flower.blue": "Figura Azul de Flor",
  "block.minecraft.banner.flower.brown": "Figura Marrom de Flor",
  "block.minecraft.banner.flower.cyan": "Figura Ciano de Flor",
  "block.minecraft.banner.flower.gray": "Figura Cinza de Flor",
  "block.minecraft.banner.flower.green": "Figura Verde de Flor",
  "block.minecraft.banner.flower.light_blue": "Figura Azul-Clara de Flor",
  "block.minecraft.banner.flower.light_gray": "Figura Cinza-Clara de Flor",
  "block.minecraft.banner.flower.lime": "Figura Verde-Limão de Flor",
  "block.minecraft.banner.flower.magenta": "Figura Magenta de Flor",
  "block.minecraft.banner.flower.orange": "Figura Laranja de Flor",
  "block.minecraft.banner.flower.pink": "Figura Rosa de Flor",
  "block.minecraft.banner.flower.purple": "Figura Roxa de Flor",
  "block.minecraft.banner.flower.red": "Figura Vermelha de Flor",
  "block.minecraft.banner.flower.white": "Figura Branca de Flor",
  "block.minecraft.banner.flower.yellow": "Figura Amarela de Flor",
  "block.minecraft.banner.globe.black": "Globo Preto",
  "block.minecraft.banner.globe.blue": "Globo Azul",
  "block.minecraft.banner.globe.brown": "Globo Marrom",
  "block.minecraft.banner.globe.cyan": "Globo Ciano",
  "block.minecraft.banner.globe.gray": "Globo Cinza",
  "block.minecraft.banner.globe.green": "Globo Verde",
  "block.minecraft.banner.globe.light_blue": "Globo Azul-Claro",
  "block.minecraft.banner.globe.light_gray": "Globo Cinza-Claro",
  "block.minecraft.banner.globe.lime": "Globo Verde-Limão",
  "block.minecraft.banner.globe.magenta": "Globo Magenta",
  "block.minecraft.banner.globe.orange": "Globo Laranja",
  "block.minecraft.banner.globe.pink": "Globo Rosa",
  "block.minecraft.banner.globe.purple": "Globo Roxo",
  "block.minecraft.banner.globe.red": "Globo Vermelho",
  "block.minecraft.banner.globe.white": "Globo Branco",
  "block.minecraft.banner.globe.yellow": "Globo Amarelo",
  "block.minecraft.banner.gradient.black": "Gradiente Preto",
  "block.minecraft.banner.gradient.blue": "Gradiente Azul",
  "block.minecraft.banner.gradient.brown": "Gradiente Marrom",
  "block.minecraft.banner.gradient.cyan": "Gradiente Ciano",
  "block.minecraft.banner.gradient.gray": "Gradiente Cinza",
  "block.minecraft.banner.gradient.green": "Gradiente Verde",
  "block.minecraft.banner.gradient.light_blue": "Gradiente Azul-Claro",
  "block.minecraft.banner.gradient.light_gray": "Gradiente Cinza-Claro",
  "block.minecraft.banner.gradient.lime": "Gradiente Verde-Limão",
  "block.minecraft.banner.gradient.magenta": "Gradiente Magenta",
  "block.minecraft.banner.gradient.orange": "Gradiente Laranja",
  "block.minecraft.banner.gradient.pink": "Gradiente Rosa",
  "block.minecraft.banner.gradient.purple": "Gradiente Roxo",
  "block.minecraft.banner.gradient.red": "Gradiente Vermelho",
  "block.minecraft.banner.gradient.white": "Gradiente Branco",
  "block.minecraft.banner.gradient.yellow": "Gradiente Amarelo",
  "block.minecraft.banner.gradient_up.black": "Gradiente Preto na Base",
  "block.minecraft.banner.gradient_up.blue": "Gradiente Azul na Base",
  "block.minecraft.banner.gradient_up.brown": "Gradiente Marrom na Base",
  "block.minecraft.banner.gradient_up.cyan": "Gradiente Ciano na Base",
  "block.minecraft.banner.gradient_up.gray": "Gradiente Cinza na Base",
  "block.minecraft.banner.gradient_up.green": "Gradiente Verde na Base",
  "block.minecraft.banner.gradient_up.light_blue": "Gradiente Azul-Claro na Base",
  "block.minecraft.banner.gradient_up.light_gray": "Gradiente Cinza-Claro na Base",
  "block.minecraft.banner.gradient_up.lime": "Gradiente Verde-Limão na Base",
  "block.minecraft.banner.gradient_up.magenta": "Gradiente Magenta na Base",
  "block.minecraft.banner.gradient_up.orange": "Gradiente Laranja na Base",
  "block.minecraft.banner.gradient_up.pink": "Gradiente Rosa na Base",
  "block.minecraft.banner.gradient_up.purple": "Gradiente Roxo na Base",
  "block.minecraft.banner.gradient_up.red": "Gradiente Vermelho na Base",
  "block.minecraft.banner.gradient_up.white": "Gradiente Branco na Base",
  "block.minecraft.banner.gradient_up.yellow": "Gradiente Amarelo na Base",
  "block.minecraft.banner.guster.black": "Vórtice Preto",
  "block.minecraft.banner.guster.blue": "Vórtice Azul",
  "block.minecraft.banner.guster.brown": "Vórtice Marrom",
  "block.minecraft.banner.guster.cyan": "Vórtice Ciano",
  "block.minecraft.banner.guster.gray": "Vórtice Cinza",
  "block.minecraft.banner.guster.green": "Vórtice Verde",
  "block.minecraft.banner.guster.light_blue": "Vórtice Azul-Claro",
  "block.minecraft.banner.guster.light_gray": "Vórtice Cinza-Claro",
  "block.minecraft.banner.guster.lime": "Vórtice Verde-Limão",
  "block.minecraft.banner.guster.magenta": "Vórtice Magenta",
  "block.minecraft.banner.guster.orange": "Vórtice Laranja",
  "block.minecraft.banner.guster.pink": "Vórtice Rosa",
  "block.minecraft.banner.guster.purple": "Vórtice Roxo",
  "block.minecraft.banner.guster.red": "Vórtice Vermelho",
  "block.minecraft.banner.guster.white": "Vórtice Branco",
  "block.minecraft.banner.guster.yellow": "Vórtice Amarelo",
  "block.minecraft.banner.half_horizontal.black": "Cortado Preto",
  "block.minecraft.banner.half_horizontal.blue": "Cortado Azul",
  "block.minecraft.banner.half_horizontal.brown": "Cortado Marrom",
  "block.minecraft.banner.half_horizontal.cyan": "Cortado Ciano",
  "block.minecraft.banner.half_horizontal.gray": "Cortado Cinza",
  "block.minecraft.banner.half_horizontal.green": "Cortado Verde",
  "block.minecraft.banner.half_horizontal.light_blue": "Cortado Azul-Claro",
  "block.minecraft.banner.half_horizontal.light_gray": "Cortado Cinza-Claro",
  "block.minecraft.banner.half_horizontal.lime": "Cortado Verde-Limão",
  "block.minecraft.banner.half_horizontal.magenta": "Cortado Magenta",
  "block.minecraft.banner.half_horizontal.orange": "Cortado Laranja",
  "block.minecraft.banner.half_horizontal.pink": "Cortado Rosa",
  "block.minecraft.banner.half_horizontal.purple": "Cortado Roxo",
  "block.minecraft.banner.half_horizontal.red": "Cortado Vermelho",
  "block.minecraft.banner.half_horizontal.white": "Cortado Branco",
  "block.minecraft.banner.half_horizontal.yellow": "Cortado Amarelo",
  "block.minecraft.banner.half_horizontal_bottom.black": "Cortado Preto Invertido",
  "block.minecraft.banner.half_horizontal_bottom.blue": "Cortado Azul Invertido",
  "block.minecraft.banner.half_horizontal_bottom.brown": "Cortado Marrom Invertido",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "Cortado Ciano Invertido",
  "block.minecraft.banner.half_horizontal_bottom.gray": "Cortado Cinza Invertido",
  "block.minecraft.banner.half_horizontal_bottom.green": "Cortado Verde Invertido",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "Cortado Azul-Claro Invertido",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "Cortado Cinza-Claro Invertido",
  "block.minecraft.banner.half_horizontal_bottom.lime": "Cortado Verde-Limão Invertido",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "Cortado Magenta Invertido",
  "block.minecraft.banner.half_horizontal_bottom.orange": "Cortado Laranja Invertido",
  "block.minecraft.banner.half_horizontal_bottom.pink": "Cortado Rosa Invertido",
  "block.minecraft.banner.half_horizontal_bottom.purple": "Cortado Roxo Invertido",
  "block.minecraft.banner.half_horizontal_bottom.red": "Cortado Vermelho Invertido",
  "block.minecraft.banner.half_horizontal_bottom.white": "Cortado Branco Invertido",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "Cortado Amarelo Invertido",
  "block.minecraft.banner.half_vertical.black": "Partido Preto",
  "block.minecraft.banner.half_vertical.blue": "Partido Azul",
  "block.minecraft.banner.half_vertical.brown": "Partido Marrom",
  "block.minecraft.banner.half_vertical.cyan": "Partido Ciano",
  "block.minecraft.banner.half_vertical.gray": "Partido Cinza",
  "block.minecraft.banner.half_vertical.green": "Partido Verde",
  "block.minecraft.banner.half_vertical.light_blue": "Partido Azul-Claro",
  "block.minecraft.banner.half_vertical.light_gray": "Partido Cinza-Claro",
  "block.minecraft.banner.half_vertical.lime": "Partido Verde-Limão",
  "block.minecraft.banner.half_vertical.magenta": "Partido Magenta",
  "block.minecraft.banner.half_vertical.orange": "Partido Laranja",
  "block.minecraft.banner.half_vertical.pink": "Partido Rosa",
  "block.minecraft.banner.half_vertical.purple": "Partido Roxo",
  "block.minecraft.banner.half_vertical.red": "Partido Vermelho",
  "block.minecraft.banner.half_vertical.white": "Partido Branco",
  "block.minecraft.banner.half_vertical.yellow": "Partido Amarelo",
  "block.minecraft.banner.half_vertical_right.black": "Partido Preto Invertido",
  "block.minecraft.banner.half_vertical_right.blue": "Partido Azul Invertido",
  "block.minecraft.banner.half_vertical_right.brown": "Partido Marrom Invertido",
  "block.minecraft.banner.half_vertical_right.cyan": "Partido Ciano Invertido",
  "block.minecraft.banner.half_vertical_right.gray": "Partido Cinza Invertido",
  "block.minecraft.banner.half_vertical_right.green": "Partido Verde Invertido",
  "block.minecraft.banner.half_vertical_right.light_blue": "Partido Azul-Claro Invertido",
  "block.minecraft.banner.half_vertical_right.light_gray": "Partido Cinza-Claro Invertido",
  "block.minecraft.banner.half_vertical_right.lime": "Partido Verde-Limão Invertido",
  "block.minecraft.banner.half_vertical_right.magenta": "Partido Magenta Invertido",
  "block.minecraft.banner.half_vertical_right.orange": "Partido Laranja Invertido",
  "block.minecraft.banner.half_vertical_right.pink": "Partido Rosa Invertido",
  "block.minecraft.banner.half_vertical_right.purple": "Partido Roxo Invertido",
  "block.minecraft.banner.half_vertical_right.red": "Partido Vermelho Invertido",
  "block.minecraft.banner.half_vertical_right.white": "Partido Branco Invertido",
  "block.minecraft.banner.half_vertical_right.yellow": "Partido Amarelo Invertido",
  "block.minecraft.banner.mojang.black": "Emblema Preto",
  "block.minecraft.banner.mojang.blue": "Emblema Azul",
  "block.minecraft.banner.mojang.brown": "Emblema Marrom",
  "block.minecraft.banner.mojang.cyan": "Emblema Ciano",
  "block.minecraft.banner.mojang.gray": "Emblema Cinza",
  "block.minecraft.banner.mojang.green": "Emblema Verde",
  "block.minecraft.banner.mojang.light_blue": "Emblema Azul-Claro",
  "block.minecraft.banner.mojang.light_gray": "Emblema Cinza-Claro",
  "block.minecraft.banner.mojang.lime": "Emblema Verde-Limão",
  "block.minecraft.banner.mojang.magenta": "Emblema Magenta",
  "block.minecraft.banner.mojang.orange": "Emblema Laranja",
  "block.minecraft.banner.mojang.pink": "Emblema Rosa",
  "block.minecraft.banner.mojang.purple": "Emblema Roxo",
  "block.minecraft.banner.mojang.red": "Emblema Vermelho",
  "block.minecraft.banner.mojang.white": "Emblema Branco",
  "block.minecraft.banner.mojang.yellow": "Emblema Amarelo",
  "block.minecraft.banner.piglin.black": "Focinho Preto",
  "block.minecraft.banner.piglin.blue": "Focinho Azul",
  "block.minecraft.banner.piglin.brown": "Focinho Marrom",
  "block.minecraft.banner.piglin.cyan": "Focinho Ciano",
  "block.minecraft.banner.piglin.gray": "Focinho Cinza",
  "block.minecraft.banner.piglin.green": "Focinho Verde",
  "block.minecraft.banner.piglin.light_blue": "Focinho Azul-Claro",
  "block.minecraft.banner.piglin.light_gray": "Focinho Cinza-Claro",
  "block.minecraft.banner.piglin.lime": "Focinho Verde-Limão",
  "block.minecraft.banner.piglin.magenta": "Focinho Magenta",
  "block.minecraft.banner.piglin.orange": "Focinho Laranja",
  "block.minecraft.banner.piglin.pink": "Focinho Rosa",
  "block.minecraft.banner.piglin.purple": "Focinho Roxo",
  "block.minecraft.banner.piglin.red": "Focinho Vermelho",
  "block.minecraft.banner.piglin.white": "Focinho Branco",
  "block.minecraft.banner.piglin.yellow": "Focinho Amarelo",
  "block.minecraft.banner.rhombus.black": "Losango Preto",
  "block.minecraft.banner.rhombus.blue": "Losango Azul",
  "block.minecraft.banner.rhombus.brown": "Losango Marrom",
  "block.minecraft.banner.rhombus.cyan": "Losango Ciano",
  "block.minecraft.banner.rhombus.gray": "Losango Cinza",
  "block.minecraft.banner.rhombus.green": "Losango Verde",
  "block.minecraft.banner.rhombus.light_blue": "Losango Azul-Claro",
  "block.minecraft.banner.rhombus.light_gray": "Losango Cinza-Claro",
  "block.minecraft.banner.rhombus.lime": "Losango Verde-Limão",
  "block.minecraft.banner.rhombus.magenta": "Losango Magenta",
  "block.minecraft.banner.rhombus.orange": "Losango Laranja",
  "block.minecraft.banner.rhombus.pink": "Losango Rosa",
  "block.minecraft.banner.rhombus.purple": "Losango Roxo",
  "block.minecraft.banner.rhombus.red": "Losango Vermelho",
  "block.minecraft.banner.rhombus.white": "Losango Branco",
  "block.minecraft.banner.rhombus.yellow": "Losango Amarelo",
  "block.minecraft.banner.skull.black": "Figura Preta de Caveira",
  "block.minecraft.banner.skull.blue": "Figura Azul de Caveira",
  "block.minecraft.banner.skull.brown": "Figura Marrom de Caveira",
  "block.minecraft.banner.skull.cyan": "Figura Ciano de Caveira",
  "block.minecraft.banner.skull.gray": "Figura Cinza de Caveira",
  "block.minecraft.banner.skull.green": "Figura Verde de Caveira",
  "block.minecraft.banner.skull.light_blue": "Figura Azul-Clara de Caveira",
  "block.minecraft.banner.skull.light_gray": "Figura Cinza-Clara de Caveira",
  "block.minecraft.banner.skull.lime": "Figura Verde-Limão de Caveira",
  "block.minecraft.banner.skull.magenta": "Figura Magenta de Caveira",
  "block.minecraft.banner.skull.orange": "Figura Laranja de Caveira",
  "block.minecraft.banner.skull.pink": "Figura Rosa de Caveira",
  "block.minecraft.banner.skull.purple": "Figura Roxa de Caveira",
  "block.minecraft.banner.skull.red": "Figura Vermelha de Caveira",
  "block.minecraft.banner.skull.white": "Figura Branca de Caveira",
  "block.minecraft.banner.skull.yellow": "Figura Amarela de Caveira",
  "block.minecraft.banner.small_stripes.black": "Palado Preto",
  "block.minecraft.banner.small_stripes.blue": "Palado Azul",
  "block.minecraft.banner.small_stripes.brown": "Palado Marrom",
  "block.minecraft.banner.small_stripes.cyan": "Palado Ciano",
  "block.minecraft.banner.small_stripes.gray": "Palado Cinza",
  "block.minecraft.banner.small_stripes.green": "Palado Verde",
  "block.minecraft.banner.small_stripes.light_blue": "Palado Azul-Claro",
  "block.minecraft.banner.small_stripes.light_gray": "Palado Cinza-Claro",
  "block.minecraft.banner.small_stripes.lime": "Palado Verde-Limão",
  "block.minecraft.banner.small_stripes.magenta": "Palado Magenta",
  "block.minecraft.banner.small_stripes.orange": "Palado Laranja",
  "block.minecraft.banner.small_stripes.pink": "Palado Rosa",
  "block.minecraft.banner.small_stripes.purple": "Palado Roxo",
  "block.minecraft.banner.small_stripes.red": "Palado Vermelho",
  "block.minecraft.banner.small_stripes.white": "Palado Branco",
  "block.minecraft.banner.small_stripes.yellow": "Palado Amarelo",
  "block.minecraft.banner.square_bottom_left.black": "Cantão Preto na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.blue": "Cantão Azul na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.brown": "Cantão Marrom na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.cyan": "Cantão Ciano na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.gray": "Cantão Cinza na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.green": "Cantão Verde na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.light_blue": "Cantão Azul-Claro na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.light_gray": "Cantão Cinza-Claro na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.lime": "Cantão Verde-Limão na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.magenta": "Cantão Magenta na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.orange": "Cantão Laranja na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.pink": "Cantão Rosa na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.purple": "Cantão Roxo na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.red": "Cantão Vermelho na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.white": "Cantão Branco na Ponta Dextra",
  "block.minecraft.banner.square_bottom_left.yellow": "Cantão Amarelo na Ponta Dextra",
  "block.minecraft.banner.square_bottom_right.black": "Cantão Preto na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.blue": "Cantão Azul na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.brown": "Cantão Marrom na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.cyan": "Cantão Ciano na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.gray": "Cantão Cinza na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.green": "Cantão Verde na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.light_blue": "Cantão Azul-Claro na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.light_gray": "Cantão Cinza-Claro na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.lime": "Cantão Verde-Limão na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.magenta": "Cantão Magenta na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.orange": "Cantão Laranja na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.pink": "Cantão Rosa na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.purple": "Cantão Roxo na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.red": "Cantão Vermelho na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.white": "Cantão Branco na Ponta Sinistra",
  "block.minecraft.banner.square_bottom_right.yellow": "Cantão Amarelo na Ponta Sinistra",
  "block.minecraft.banner.square_top_left.black": "Cantão Preto no Chefe Dextro",
  "block.minecraft.banner.square_top_left.blue": "Cantão Azul no Chefe Dextro",
  "block.minecraft.banner.square_top_left.brown": "Cantão Marrom no Chefe Dextro",
  "block.minecraft.banner.square_top_left.cyan": "Cantão Ciano no Chefe Dextro",
  "block.minecraft.banner.square_top_left.gray": "Cantão Cinza no Chefe Dextro",
  "block.minecraft.banner.square_top_left.green": "Cantão Verde no Chefe Dextro",
  "block.minecraft.banner.square_top_left.light_blue": "Cantão Azul-Claro no Chefe Dextro",
  "block.minecraft.banner.square_top_left.light_gray": "Cantão Cinza-Claro no Chefe Dextro",
  "block.minecraft.banner.square_top_left.lime": "Cantão Verde-Limão no Chefe Dextro",
  "block.minecraft.banner.square_top_left.magenta": "Cantão Magenta no Chefe Dextro",
  "block.minecraft.banner.square_top_left.orange": "Cantão Laranja no Chefe Dextro",
  "block.minecraft.banner.square_top_left.pink": "Cantão Rosa no Chefe Dextro",
  "block.minecraft.banner.square_top_left.purple": "Cantão Roxo no Chefe Dextro",
  "block.minecraft.banner.square_top_left.red": "Cantão Vermelho no Chefe Dextro",
  "block.minecraft.banner.square_top_left.white": "Cantão Branco no Chefe Dextro",
  "block.minecraft.banner.square_top_left.yellow": "Cantão Amarelo no Chefe Dextro",
  "block.minecraft.banner.square_top_right.black": "Cantão Preto no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.blue": "Cantão Azul no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.brown": "Cantão Marrom no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.cyan": "Cantão Ciano no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.gray": "Cantão Cinza no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.green": "Cantão Verde no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.light_blue": "Cantão Azul-Claro no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.light_gray": "Cantão Cinza-Claro no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.lime": "Cantão Verde-Limão no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.magenta": "Cantão Magenta no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.orange": "Cantão Laranja no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.pink": "Cantão Rosa no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.purple": "Cantão Roxo no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.red": "Cantão Vermelho no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.white": "Cantão Branco no Chefe Sinistro",
  "block.minecraft.banner.square_top_right.yellow": "Cantão Amarelo no Chefe Sinistro",
  "block.minecraft.banner.straight_cross.black": "Cruz Preta",
  "block.minecraft.banner.straight_cross.blue": "Cruz Azul",
  "block.minecraft.banner.straight_cross.brown": "Cruz Marrom",
  "block.minecraft.banner.straight_cross.cyan": "Cruz Ciano",
  "block.minecraft.banner.straight_cross.gray": "Cruz Cinza",
  "block.minecraft.banner.straight_cross.green": "Cruz Verde",
  "block.minecraft.banner.straight_cross.light_blue": "Cruz Azul-Clara",
  "block.minecraft.banner.straight_cross.light_gray": "Cruz Cinza-Clara",
  "block.minecraft.banner.straight_cross.lime": "Cruz Verde-Limão",
  "block.minecraft.banner.straight_cross.magenta": "Cruz Magenta",
  "block.minecraft.banner.straight_cross.orange": "Cruz Laranja",
  "block.minecraft.banner.straight_cross.pink": "Cruz Rosa",
  "block.minecraft.banner.straight_cross.purple": "Cruz Roxa",
  "block.minecraft.banner.straight_cross.red": "Cruz Vermelha",
  "block.minecraft.banner.straight_cross.white": "Cruz Branca",
  "block.minecraft.banner.straight_cross.yellow": "Cruz Amarela",
  "block.minecraft.banner.stripe_bottom.black": "Base Preta",
  "block.minecraft.banner.stripe_bottom.blue": "Base Azul",
  "block.minecraft.banner.stripe_bottom.brown": "Base Marrom",
  "block.minecraft.banner.stripe_bottom.cyan": "Base Ciano",
  "block.minecraft.banner.stripe_bottom.gray": "Base Cinza",
  "block.minecraft.banner.stripe_bottom.green": "Base Verde",
  "block.minecraft.banner.stripe_bottom.light_blue": "Base Azul-Clara",
  "block.minecraft.banner.stripe_bottom.light_gray": "Base Cinza-Clara",
  "block.minecraft.banner.stripe_bottom.lime": "Base Verde-Limão",
  "block.minecraft.banner.stripe_bottom.magenta": "Base Magenta",
  "block.minecraft.banner.stripe_bottom.orange": "Base Laranja",
  "block.minecraft.banner.stripe_bottom.pink": "Base Rosa",
  "block.minecraft.banner.stripe_bottom.purple": "Base Roxa",
  "block.minecraft.banner.stripe_bottom.red": "Base Vermelha",
  "block.minecraft.banner.stripe_bottom.white": "Base Branca",
  "block.minecraft.banner.stripe_bottom.yellow": "Base Amarela",
  "block.minecraft.banner.stripe_center.black": "Pala Preta",
  "block.minecraft.banner.stripe_center.blue": "Pala Azul",
  "block.minecraft.banner.stripe_center.brown": "Pala Marrom",
  "block.minecraft.banner.stripe_center.cyan": "Pala Ciano",
  "block.minecraft.banner.stripe_center.gray": "Pala Cinza",
  "block.minecraft.banner.stripe_center.green": "Pala Verde",
  "block.minecraft.banner.stripe_center.light_blue": "Pala Azul-Clara",
  "block.minecraft.banner.stripe_center.light_gray": "Pala Cinza-Clara",
  "block.minecraft.banner.stripe_center.lime": "Pala Verde-Limão",
  "block.minecraft.banner.stripe_center.magenta": "Pala Magenta",
  "block.minecraft.banner.stripe_center.orange": "Pala Laranja",
  "block.minecraft.banner.stripe_center.pink": "Pala Rosa",
  "block.minecraft.banner.stripe_center.purple": "Pala Roxa",
  "block.minecraft.banner.stripe_center.red": "Pala Vermelha",
  "block.minecraft.banner.stripe_center.white": "Pala Branca",
  "block.minecraft.banner.stripe_center.yellow": "Pala Amarela",
  "block.minecraft.banner.stripe_downleft.black": "Banda Sinistra Preta",
  "block.minecraft.banner.stripe_downleft.blue": "Banda Sinistra Azul",
  "block.minecraft.banner.stripe_downleft.brown": "Banda Sinistra Marrom",
  "block.minecraft.banner.stripe_downleft.cyan": "Banda Sinistra Ciano",
  "block.minecraft.banner.stripe_downleft.gray": "Banda Sinistra Cinza",
  "block.minecraft.banner.stripe_downleft.green": "Banda Sinistra Verde",
  "block.minecraft.banner.stripe_downleft.light_blue": "Banda Sinistra Azul-Clara",
  "block.minecraft.banner.stripe_downleft.light_gray": "Banda Sinistra Cinza-Clara",
  "block.minecraft.banner.stripe_downleft.lime": "Banda Sinistra Verde-Limão",
  "block.minecraft.banner.stripe_downleft.magenta": "Banda Sinistra Magenta",
  "block.minecraft.banner.stripe_downleft.orange": "Banda Sinistra Laranja",
  "block.minecraft.banner.stripe_downleft.pink": "Banda Sinistra Rosa",
  "block.minecraft.banner.stripe_downleft.purple": "Banda Sinistra Roxa",
  "block.minecraft.banner.stripe_downleft.red": "Banda Sinistra Vermelha",
  "block.minecraft.banner.stripe_downleft.white": "Banda Sinistra Branca",
  "block.minecraft.banner.stripe_downleft.yellow": "Banda Sinistra Amarela",
  "block.minecraft.banner.stripe_downright.black": "Banda Preta",
  "block.minecraft.banner.stripe_downright.blue": "Banda Azul",
  "block.minecraft.banner.stripe_downright.brown": "Banda Marrom",
  "block.minecraft.banner.stripe_downright.cyan": "Banda Ciano",
  "block.minecraft.banner.stripe_downright.gray": "Banda Cinza",
  "block.minecraft.banner.stripe_downright.green": "Banda Verde",
  "block.minecraft.banner.stripe_downright.light_blue": "Banda Azul-Clara",
  "block.minecraft.banner.stripe_downright.light_gray": "Banda Cinza-Clara",
  "block.minecraft.banner.stripe_downright.lime": "Banda Verde-Limão",
  "block.minecraft.banner.stripe_downright.magenta": "Banda Magenta",
  "block.minecraft.banner.stripe_downright.orange": "Banda Laranja",
  "block.minecraft.banner.stripe_downright.pink": "Banda Rosa",
  "block.minecraft.banner.stripe_downright.purple": "Banda Roxa",
  "block.minecraft.banner.stripe_downright.red": "Banda Vermelha",
  "block.minecraft.banner.stripe_downright.white": "Banda Branca",
  "block.minecraft.banner.stripe_downright.yellow": "Banda Amarela",
  "block.minecraft.banner.stripe_left.black": "Pala Dextra Preta",
  "block.minecraft.banner.stripe_left.blue": "Pala Dextra Azul",
  "block.minecraft.banner.stripe_left.brown": "Pala Dextra Marrom",
  "block.minecraft.banner.stripe_left.cyan": "Pala Dextra Ciano",
  "block.minecraft.banner.stripe_left.gray": "Pala Dextra Cinza",
  "block.minecraft.banner.stripe_left.green": "Pala Dextra Verde",
  "block.minecraft.banner.stripe_left.light_blue": "Pala Dextra Azul-Clara",
  "block.minecraft.banner.stripe_left.light_gray": "Pala Dextra Cinza-Clara",
  "block.minecraft.banner.stripe_left.lime": "Pala Dextra Verde-Limão",
  "block.minecraft.banner.stripe_left.magenta": "Pala Dextra Magenta",
  "block.minecraft.banner.stripe_left.orange": "Pala Dextra Laranja",
  "block.minecraft.banner.stripe_left.pink": "Pala Dextra Rosa",
  "block.minecraft.banner.stripe_left.purple": "Pala Dextra Roxa",
  "block.minecraft.banner.stripe_left.red": "Pala Dextra Vermelha",
  "block.minecraft.banner.stripe_left.white": "Pala Dextra Branca",
  "block.minecraft.banner.stripe_left.yellow": "Pala Dextra Amarela",
  "block.minecraft.banner.stripe_middle.black": "Faixa Preta",
  "block.minecraft.banner.stripe_middle.blue": "Faixa Azul",
  "block.minecraft.banner.stripe_middle.brown": "Faixa Marrom",
  "block.minecraft.banner.stripe_middle.cyan": "Faixa Ciano",
  "block.minecraft.banner.stripe_middle.gray": "Faixa Cinza",
  "block.minecraft.banner.stripe_middle.green": "Faixa Verde",
  "block.minecraft.banner.stripe_middle.light_blue": "Faixa Azul-Clara",
  "block.minecraft.banner.stripe_middle.light_gray": "Faixa Cinza-Clara",
  "block.minecraft.banner.stripe_middle.lime": "Faixa Verde-Limão",
  "block.minecraft.banner.stripe_middle.magenta": "Faixa Magenta",
  "block.minecraft.banner.stripe_middle.orange": "Faixa Laranja",
  "block.minecraft.banner.stripe_middle.pink": "Faixa Rosa",
  "block.minecraft.banner.stripe_middle.purple": "Faixa Roxa",
  "block.minecraft.banner.stripe_middle.red": "Faixa Vermelha",
  "block.minecraft.banner.stripe_middle.white": "Faixa Branca",
  "block.minecraft.banner.stripe_middle.yellow": "Faixa Amarela",
  "block.minecraft.banner.stripe_right.black": "Pala Sinistra Preta",
  "block.minecraft.banner.stripe_right.blue": "Pala Sinistra Azul",
  "block.minecraft.banner.stripe_right.brown": "Pala Sinistra Marrom",
  "block.minecraft.banner.stripe_right.cyan": "Pala Sinistra Ciano",
  "block.minecraft.banner.stripe_right.gray": "Pala Sinistra Cinza",
  "block.minecraft.banner.stripe_right.green": "Pala Sinistra Verde",
  "block.minecraft.banner.stripe_right.light_blue": "Pala Sinistra Azul-Clara",
  "block.minecraft.banner.stripe_right.light_gray": "Pala Sinistra Cinza-Clara",
  "block.minecraft.banner.stripe_right.lime": "Pala Sinistra Verde-Limão",
  "block.minecraft.banner.stripe_right.magenta": "Pala Sinistra Magenta",
  "block.minecraft.banner.stripe_right.orange": "Pala Sinistra Laranja",
  "block.minecraft.banner.stripe_right.pink": "Pala Sinistra Rosa",
  "block.minecraft.banner.stripe_right.purple": "Pala Sinistra Roxa",
  "block.minecraft.banner.stripe_right.red": "Pala Sinistra Vermelha",
  "block.minecraft.banner.stripe_right.white": "Pala Sinistra Branca",
  "block.minecraft.banner.stripe_right.yellow": "Pala Sinistra Amarela",
  "block.minecraft.banner.stripe_top.black": "Chefe Preto",
  "block.minecraft.banner.stripe_top.blue": "Chefe Azul",
  "block.minecraft.banner.stripe_top.brown": "Chefe Marrom",
  "block.minecraft.banner.stripe_top.cyan": "Chefe Ciano",
  "block.minecraft.banner.stripe_top.gray": "Chefe Cinza",
  "block.minecraft.banner.stripe_top.green": "Chefe Verde",
  "block.minecraft.banner.stripe_top.light_blue": "Chefe Azul-Claro",
  "block.minecraft.banner.stripe_top.light_gray": "Chefe Cinza-Claro",
  "block.minecraft.banner.stripe_top.lime": "Chefe Verde-Limão",
  "block.minecraft.banner.stripe_top.magenta": "Chefe Magenta",
  "block.minecraft.banner.stripe_top.orange": "Chefe Laranja",
  "block.minecraft.banner.stripe_top.pink": "Chefe Rosa",
  "block.minecraft.banner.stripe_top.purple": "Chefe Roxo",
  "block.minecraft.banner.stripe_top.red": "Chefe Vermelho",
  "block.minecraft.banner.stripe_top.white": "Chefe Branco",
  "block.minecraft.banner.stripe_top.yellow": "Chefe Amarelo",
  "block.minecraft.banner.triangle_bottom.black": "Asna Preta",
  "block.minecraft.banner.triangle_bottom.blue": "Asna Azul",
  "block.minecraft.banner.triangle_bottom.brown": "Asna Marrom",
  "block.minecraft.banner.triangle_bottom.cyan": "Asna Ciano",
  "block.minecraft.banner.triangle_bottom.gray": "Asna Cinza",
  "block.minecraft.banner.triangle_bottom.green": "Asna Verde",
  "block.minecraft.banner.triangle_bottom.light_blue": "Asna Azul-Clara",
  "block.minecraft.banner.triangle_bottom.light_gray": "Asna Cinza-Clara",
  "block.minecraft.banner.triangle_bottom.lime": "Asna Verde-Limão",
  "block.minecraft.banner.triangle_bottom.magenta": "Asna Magenta",
  "block.minecraft.banner.triangle_bottom.orange": "Asna Laranja",
  "block.minecraft.banner.triangle_bottom.pink": "Asna Rosa",
  "block.minecraft.banner.triangle_bottom.purple": "Asna Roxa",
  "block.minecraft.banner.triangle_bottom.red": "Asna Vermelha",
  "block.minecraft.banner.triangle_bottom.white": "Asna Branca",
  "block.minecraft.banner.triangle_bottom.yellow": "Asna Amarela",
  "block.minecraft.banner.triangle_top.black": "Asna Preta Invertida",
  "block.minecraft.banner.triangle_top.blue": "Asna Azul Invertida",
  "block.minecraft.banner.triangle_top.brown": "Asna Marrom Invertida",
  "block.minecraft.banner.triangle_top.cyan": "Asna Ciano Invertida",
  "block.minecraft.banner.triangle_top.gray": "Asna Cinza Invertida",
  "block.minecraft.banner.triangle_top.green": "Asna Verde Invertida",
  "block.minecraft.banner.triangle_top.light_blue": "Asna Azul-Clara Invertida",
  "block.minecraft.banner.triangle_top.light_gray": "Asna Cinza-Clara Invertida",
  "block.minecraft.banner.triangle_top.lime": "Asna Verde-Limão Invertida",
  "block.minecraft.banner.triangle_top.magenta": "Asna Magenta Invertida",
  "block.minecraft.banner.triangle_top.orange": "Asna Laranja Invertida",
  "block.minecraft.banner.triangle_top.pink": "Asna Rosa Invertida",
  "block.minecraft.banner.triangle_top.purple": "Asna Roxa Invertida",
  "block.minecraft.banner.triangle_top.red": "Asna Vermelha Invertida",
  "block.minecraft.banner.triangle_top.white": "Asna Branca Invertida",
  "block.minecraft.banner.triangle_top.yellow": "Asna Amarela Invertida",
  "block.minecraft.banner.triangles_bottom.black": "Dentado Preto na Base",
  "block.minecraft.banner.triangles_bottom.blue": "Dentado Azul na Base",
  "block.minecraft.banner.triangles_bottom.brown": "Dentado Marrom na Base",
  "block.minecraft.banner.triangles_bottom.cyan": "Dentado Ciano na Base",
  "block.minecraft.banner.triangles_bottom.gray": "Dentado Cinza na Base",
  "block.minecraft.banner.triangles_bottom.green": "Dentado Verde na Base",
  "block.minecraft.banner.triangles_bottom.light_blue": "Dentado Azul-Claro na Base",
  "block.minecraft.banner.triangles_bottom.light_gray": "Dentado Cinza-Claro na Base",
  "block.minecraft.banner.triangles_bottom.lime": "Dentado Verde-Limão na Base",
  "block.minecraft.banner.triangles_bottom.magenta": "Dentado Magenta na Base",
  "block.minecraft.banner.triangles_bottom.orange": "Dentado Laranja na Base",
  "block.minecraft.banner.triangles_bottom.pink": "Dentado Rosa na Base",
  "block.minecraft.banner.triangles_bottom.purple": "Dentado Roxo na Base",
  "block.minecraft.banner.triangles_bottom.red": "Dentado Vermelho na Base",
  "block.minecraft.banner.triangles_bottom.white": "Dentado Branco na Base",
  "block.minecraft.banner.triangles_bottom.yellow": "Dentado Amarelo na Base",
  "block.minecraft.banner.triangles_top.black": "Dentado Preto no Chefe",
  "block.minecraft.banner.triangles_top.blue": "Dentado Azul no Chefe",
  "block.minecraft.banner.triangles_top.brown": "Dentado Marrom no Chefe",
  "block.minecraft.banner.triangles_top.cyan": "Dentado Ciano no Chefe",
  "block.minecraft.banner.triangles_top.gray": "Dentado Cinza no Chefe",
  "block.minecraft.banner.triangles_top.green": "Dentado Verde no Chefe",
  "block.minecraft.banner.triangles_top.light_blue": "Dentado Azul-Claro no Chefe",
  "block.minecraft.banner.triangles_top.light_gray": "Dentado Cinza-Claro no Chefe",
  "block.minecraft.banner.triangles_top.lime": "Dentado Verde-Limão no Chefe",
  "block.minecraft.banner.triangles_top.magenta": "Dentado Magenta no Chefe",
  "block.minecraft.banner.triangles_top.orange": "Dentado Laranja no Chefe",
  "block.minecraft.banner.triangles_top.pink": "Dentado Rosa no Chefe",
  "block.minecraft.banner.triangles_top.purple": "Dentado Roxo no Chefe",
  "block.minecraft.banner.triangles_top.red": "Dentado Vermelho no Chefe",
  "block.minecraft.banner.triangles_top.white": "Dentado Branco no Chefe",
  "block.minecraft.banner.triangles_top.yellow": "Dentado Amarelo no Chefe",
  "block.minecraft.barrel": "Barril",
  "block.minecraft.barrier": "Barreira",
  "block.minecraft.basalt": "Basalto",
  "block.minecraft.beacon": "Sinalizador",
  "block.minecraft.beacon.primary": "Poder primário",
  "block.minecraft.beacon.secondary": "Poder secundário",
  "block.minecraft.bed.no_sleep": "Você só pode dormir à noite ou durante temporais",
  "block.minecraft.bed.not_safe": "Você não pode dormir agora, há monstros por perto",
  "block.minecraft.bed.obstructed": "Essa cama está obstruída",
  "block.minecraft.bed.occupied": "Essa cama está ocupada",
  "block.minecraft.bed.too_far_away": "A cama está longe demais para dormir agora",
  "block.minecraft.bedrock": "Rocha Matriz",
  "block.minecraft.bee_nest": "Colmeia",
  "block.minecraft.beehive": "Colmeia Artificial",
  "block.minecraft.beetroots": "Beterrabas",
  "block.minecraft.bell": "Sino",
  "block.minecraft.big_dripleaf": "Plantaforma Grande",
  "block.minecraft.big_dripleaf_stem": "Caule de Plantaforma Grande",
  "block.minecraft.birch_button": "Botão de Bétula",
  "block.minecraft.birch_door": "Porta de Bétula",
  "block.minecraft.birch_fence": "Cerca de Bétula",
  "block.minecraft.birch_fence_gate": "Portão de Bétula",
  "block.minecraft.birch_hanging_sign": "Placa Suspensa de Bétula",
  "block.minecraft.birch_leaves": "Folhas de Bétula",
  "block.minecraft.birch_log": "Tronco de Bétula",
  "block.minecraft.birch_planks": "Tábuas de Bétula",
  "block.minecraft.birch_pressure_plate": "Placa de Pressão de Bétula",
  "block.minecraft.birch_sapling": "Muda de Bétula",
  "block.minecraft.birch_shelf": "Estante de Bétula",
  "block.minecraft.birch_sign": "Placa de Bétula",
  "block.minecraft.birch_slab": "Laje de Bétula",
  "block.minecraft.birch_stairs": "Escadas de Bétula",
  "block.minecraft.birch_trapdoor": "Alçapão de Bétula",
  "block.minecraft.birch_wall_hanging_sign": "Placa Suspensa de Bétula de Parede",
  "block.minecraft.birch_wall_sign": "Placa de Bétula de Parede",
  "block.minecraft.birch_wood": "Madeira de Bétula",
  "block.minecraft.black_banner": "Estandarte Preto",
  "block.minecraft.black_bed": "Cama Preta",
  "block.minecraft.black_candle": "Vela Preta",
  "block.minecraft.black_candle_cake": "Bolo com Vela Preta",
  "block.minecraft.black_carpet": "Tapete Preto",
  "block.minecraft.black_concrete": "Concreto Preto",
  "block.minecraft.black_concrete_powder": "Cimento Preto",
  "block.minecraft.black_glazed_terracotta": "Azulejo Preto",
  "block.minecraft.black_shulker_box": "Caixa de Shulker Preta",
  "block.minecraft.black_stained_glass": "Vidro Preto",
  "block.minecraft.black_stained_glass_pane": "Vidraça Preta",
  "block.minecraft.black_terracotta": "Terracota Preta",
  "block.minecraft.black_wool": "Lã Preta",
  "block.minecraft.blackstone": "Pedra-Negra",
  "block.minecraft.blackstone_slab": "Laje de Pedra-Negra",
  "block.minecraft.blackstone_stairs": "Escadas de Pedra-Negra",
  "block.minecraft.blackstone_wall": "Muro de Pedra-Negra",
  "block.minecraft.blast_furnace": "Alto-Forno",
  "block.minecraft.blue_banner": "Estandarte Azul",
  "block.minecraft.blue_bed": "Cama Azul",
  "block.minecraft.blue_candle": "Vela Azul",
  "block.minecraft.blue_candle_cake": "Bolo com Vela Azul",
  "block.minecraft.blue_carpet": "Tapete Azul",
  "block.minecraft.blue_concrete": "Concreto Azul",
  "block.minecraft.blue_concrete_powder": "Cimento Azul",
  "block.minecraft.blue_glazed_terracotta": "Azulejo Azul",
  "block.minecraft.blue_ice": "Gelo Azul",
  "block.minecraft.blue_orchid": "Orquídea-Azul",
  "block.minecraft.blue_shulker_box": "Caixa de Shulker Azul",
  "block.minecraft.blue_stained_glass": "Vidro Azul",
  "block.minecraft.blue_stained_glass_pane": "Vidraça Azul",
  "block.minecraft.blue_terracotta": "Terracota Azul",
  "block.minecraft.blue_wool": "Lã Azul",
  "block.minecraft.bone_block": "Bloco de Ossos",
  "block.minecraft.bookshelf": "Estante de Livros",
  "block.minecraft.brain_coral": "Coral-de-Cérebro",
  "block.minecraft.brain_coral_block": "Bloco de Coral-de-Cérebro",
  "block.minecraft.brain_coral_fan": "Gorgônia-de-Cérebro",
  "block.minecraft.brain_coral_wall_fan": "Gorgônia-de-Cérebro de Parede",
  "block.minecraft.brewing_stand": "Suporte de Poções",
  "block.minecraft.brick_slab": "Laje de Tijolos",
  "block.minecraft.brick_stairs": "Escadas de Tijolos",
  "block.minecraft.brick_wall": "Muro de Tijolos",
  "block.minecraft.bricks": "Tijolos",
  "block.minecraft.brown_banner": "Estandarte Marrom",
  "block.minecraft.brown_bed": "Cama Marrom",
  "block.minecraft.brown_candle": "Vela Marrom",
  "block.minecraft.brown_candle_cake": "Bolo com Vela Marrom",
  "block.minecraft.brown_carpet": "Tapete Marrom",
  "block.minecraft.brown_concrete": "Concreto Marrom",
  "block.minecraft.brown_concrete_powder": "Cimento Marrom",
  "block.minecraft.brown_glazed_terracotta": "Azulejo Marrom",
  "block.minecraft.brown_mushroom": "Cogumelo Marrom",
  "block.minecraft.brown_mushroom_block": "Bloco de Cogumelo Marrom",
  "block.minecraft.brown_shulker_box": "Caixa de Shulker Marrom",
  "block.minecraft.brown_stained_glass": "Vidro Marrom",
  "block.minecraft.brown_stained_glass_pane": "Vidraça Marrom",
  "block.minecraft.brown_terracotta": "Terracota Marrom",
  "block.minecraft.brown_wool": "Lã Marrom",
  "block.minecraft.bubble_column": "Coluna de Bolhas",
  "block.minecraft.bubble_coral": "Coral-de-Bolha",
  "block.minecraft.bubble_coral_block": "Bloco de Coral-de-Bolha",
  "block.minecraft.bubble_coral_fan": "Gorgônia-de-Bolha",
  "block.minecraft.bubble_coral_wall_fan": "Gorgônia-de-Bolha de Parede",
  "block.minecraft.budding_amethyst": "Drusa de Ametista",
  "block.minecraft.bush": "Arbusto",
  "block.minecraft.cactus": "Cacto",
  "block.minecraft.cactus_flower": "Flor de Cacto",
  "block.minecraft.cake": "Bolo",
  "block.minecraft.calcite": "Calcita",
  "block.minecraft.calibrated_sculk_sensor": "Sensor de Sculk Calibrado",
  "block.minecraft.campfire": "Fogueira",
  "block.minecraft.candle": "Vela",
  "block.minecraft.candle_cake": "Bolo com Vela",
  "block.minecraft.carrots": "Cenouras",
  "block.minecraft.cartography_table": "Bancada de Cartografia",
  "block.minecraft.carved_pumpkin": "Abóbora Esculpida",
  "block.minecraft.cauldron": "Caldeirão",
  "block.minecraft.cave_air": "Ar da Caverna",
  "block.minecraft.cave_vines": "Trepadeiras das Cavernas",
  "block.minecraft.cave_vines_plant": "Planta de Trepadeiras das Cavernas",
  "block.minecraft.chain": "Corrente",
  "block.minecraft.chain_command_block": "Bloco de Comando em Cadeia",
  "block.minecraft.cherry_button": "Botão de Cerejeira",
  "block.minecraft.cherry_door": "Porta de Cerejeira",
  "block.minecraft.cherry_fence": "Cerca de Cerejeira",
  "block.minecraft.cherry_fence_gate": "Portão de Cerejeira",
  "block.minecraft.cherry_hanging_sign": "Placa Suspensa de Cerejeira",
  "block.minecraft.cherry_leaves": "Folhas de Cerejeira",
  "block.minecraft.cherry_log": "Tronco de Cerejeira",
  "block.minecraft.cherry_planks": "Tábuas de Cerejeira",
  "block.minecraft.cherry_pressure_plate": "Placa de Pressão de Cerejeira",
  "block.minecraft.cherry_sapling": "Muda de Cerejeira",
  "block.minecraft.cherry_shelf": "Estante de Cerejeira",
  "block.minecraft.cherry_sign": "Placa de Cerejeira",
  "block.minecraft.cherry_slab": "Laje de Cerejeira",
  "block.minecraft.cherry_stairs": "Escadas de Cerejeira",
  "block.minecraft.cherry_trapdoor": "Alçapão de Cerejeira",
  "block.minecraft.cherry_wall_hanging_sign": "Placa Suspensa de Cerejeira de Parede",
  "block.minecraft.cherry_wall_sign": "Placa de Cerejeira de Parede",
  "block.minecraft.cherry_wood": "Madeira de Cerejeira",
  "block.minecraft.chest": "Baú",
  "block.minecraft.chipped_anvil": "Bigorna Rachada",
  "block.minecraft.chiseled_bookshelf": "Porta-Livros",
  "block.minecraft.chiseled_copper": "Cobre Talhado",
  "block.minecraft.chiseled_deepslate": "Ardosiabissal Talhada",
  "block.minecraft.chiseled_nether_bricks": "Tijolos do Nether Talhados",
  "block.minecraft.chiseled_polished_blackstone": "Pedra-Negra Polida Talhada",
  "block.minecraft.chiseled_quartz_block": "Bloco de Quartzo Talhado",
  "block.minecraft.chiseled_red_sandstone": "Arenito Vermelho Talhado",
  "block.minecraft.chiseled_resin_bricks": "Tijolos de Resina Talhados",
  "block.minecraft.chiseled_sandstone": "Arenito Talhado",
  "block.minecraft.chiseled_stone_bricks": "Tijolos de Pedra Talhados",
  "block.minecraft.chiseled_tuff": "Tufo Talhado",
  "block.minecraft.chiseled_tuff_bricks": "Tijolos de Tufo Talhados",
  "block.minecraft.chorus_flower": "Flor do Coro",
  "block.minecraft.chorus_plant": "Planta do Coro",
  "block.minecraft.clay": "Argila",
  "block.minecraft.closed_eyeblossom": "Olhoquídea Fechada",
  "block.minecraft.coal_block": "Bloco de Carvão",
  "block.minecraft.coal_ore": "Minério de Carvão",
  "block.minecraft.coarse_dirt": "Terra Infértil",
  "block.minecraft.cobbled_deepslate": "Pedregulho de Ardosiabissal",
  "block.minecraft.cobbled_deepslate_slab": "Laje de Pedregulho de Ardosiabissal",
  "block.minecraft.cobbled_deepslate_stairs": "Escadas de Pedregulho de Ardosiabissal",
  "block.minecraft.cobbled_deepslate_wall": "Muro de Pedregulho de Ardosiabissal",
  "block.minecraft.cobblestone": "Pedregulho",
  "block.minecraft.cobblestone_slab": "Laje de Pedregulho",
  "block.minecraft.cobblestone_stairs": "Escadas de Pedregulho",
  "block.minecraft.cobblestone_wall": "Muro de Pedregulho",
  "block.minecraft.cobweb": "Teia de Aranha",
  "block.minecraft.cocoa": "Cacau",
  "block.minecraft.command_block": "Bloco de Comando",
  "block.minecraft.comparator": "Comparador de Redstone",
  "block.minecraft.composter": "Composteira",
  "block.minecraft.conduit": "Conduto",
  "block.minecraft.copper_bars": "Barras de Cobre",
  "block.minecraft.copper_block": "Bloco de Cobre",
  "block.minecraft.copper_bulb": "Lâmpada de Cobre",
  "block.minecraft.copper_chain": "Corrente de Cobre",
  "block.minecraft.copper_chest": "Baú de Cobre",
  "block.minecraft.copper_door": "Porta de Cobre",
  "block.minecraft.copper_golem_statue": "Estátua de Golem de Cobre",
  "block.minecraft.copper_grate": "Grade de Cobre",
  "block.minecraft.copper_lantern": "Lampião de Cobre",
  "block.minecraft.copper_ore": "Minério de Cobre",
  "block.minecraft.copper_torch": "Tocha de Cobre",
  "block.minecraft.copper_trapdoor": "Alçapão de Cobre",
  "block.minecraft.copper_wall_torch": "Tocha de Cobre de Parede",
  "block.minecraft.cornflower": "Centáurea",
  "block.minecraft.cracked_deepslate_bricks": "Tijolos de Ardosiabissal Rachados",
  "block.minecraft.cracked_deepslate_tiles": "Ladrilhos de Ardosiabissal Rachados",
  "block.minecraft.cracked_nether_bricks": "Tijolos do Nether Rachados",
  "block.minecraft.cracked_polished_blackstone_bricks": "Tijolos de Pedra-Negra Polida Rachados",
  "block.minecraft.cracked_stone_bricks": "Tijolos de Pedra Rachados",
  "block.minecraft.crafter": "Bancada Automática",
  "block.minecraft.crafting_table": "Bancada de Trabalho",
  "block.minecraft.creaking_heart": "Coração de Rangente",
  "block.minecraft.creeper_head": "Cabeça de Creeper",
  "block.minecraft.creeper_wall_head": "Cabeça de Creeper de Parede",
  "block.minecraft.crimson_button": "Botão Carmesim",
  "block.minecraft.crimson_door": "Porta Carmesim",
  "block.minecraft.crimson_fence": "Cerca Carmesim",
  "block.minecraft.crimson_fence_gate": "Portão Carmesim",
  "block.minecraft.crimson_fungus": "Fungo Carmesim",
  "block.minecraft.crimson_hanging_sign": "Placa Suspensa Carmesim",
  "block.minecraft.crimson_hyphae": "Hifas Carmesim",
  "block.minecraft.crimson_nylium": "Nicélio Carmesim",
  "block.minecraft.crimson_planks": "Tábuas Carmesim",
  "block.minecraft.crimson_pressure_plate": "Placa de Pressão Carmesim",
  "block.minecraft.crimson_roots": "Raízes Carmesim",
  "block.minecraft.crimson_shelf": "Estante Carmesim",
  "block.minecraft.crimson_sign": "Placa Carmesim",
  "block.minecraft.crimson_slab": "Laje Carmesim",
  "block.minecraft.crimson_stairs": "Escadas Carmesim",
  "block.minecraft.crimson_stem": "Caule Carmesim",
  "block.minecraft.crimson_trapdoor": "Alçapão Carmesim",
  "block.minecraft.crimson_wall_hanging_sign": "Placa Suspensa Carmesim de Parede",
  "block.minecraft.crimson_wall_sign": "Placa Carmesim de Parede",
  "block.minecraft.crying_obsidian": "Obsidiana Chorona",
  "block.minecraft.cut_copper": "Cobre Lapidado",
  "block.minecraft.cut_copper_slab": "Laje de Cobre Lapidado",
  "block.minecraft.cut_copper_stairs": "Escadas de Cobre Lapidado",
  "block.minecraft.cut_red_sandstone": "Arenito Vermelho Lapidado",
  "block.minecraft.cut_red_sandstone_slab": "Laje de Arenito Vermelho Lapidado",
  "block.minecraft.cut_sandstone": "Arenito Lapidado",
  "block.minecraft.cut_sandstone_slab": "Laje de Arenito Lapidado",
  "block.minecraft.cyan_banner": "Estandarte Ciano",
  "block.minecraft.cyan_bed": "Cama Ciano",
  "block.minecraft.cyan_candle": "Vela Ciano",
  "block.minecraft.cyan_candle_cake": "Bolo com Vela Ciano",
  "block.minecraft.cyan_carpet": "Tapete Ciano",
  "block.minecraft.cyan_concrete": "Concreto Ciano",
  "block.minecraft.cyan_concrete_powder": "Cimento Ciano",
  "block.minecraft.cyan_glazed_terracotta": "Azulejo Ciano",
  "block.minecraft.cyan_shulker_box": "Caixa de Shulker Ciano",
  "block.minecraft.cyan_stained_glass": "Vidro Ciano",
  "block.minecraft.cyan_stained_glass_pane": "Vidraça Ciano",
  "block.minecraft.cyan_terracotta": "Terracota Ciano",
  "block.minecraft.cyan_wool": "Lã Ciano",
  "block.minecraft.damaged_anvil": "Bigorna Danificada",
  "block.minecraft.dandelion": "Dente-de-Leão",
  "block.minecraft.dark_oak_button": "Botão de Carvalho Escuro",
  "block.minecraft.dark_oak_door": "Porta de Carvalho Escuro",
  "block.minecraft.dark_oak_fence": "Cerca de Carvalho Escuro",
  "block.minecraft.dark_oak_fence_gate": "Portão de Carvalho Escuro",
  "block.minecraft.dark_oak_hanging_sign": "Placa Suspensa de Carvalho Escuro",
  "block.minecraft.dark_oak_leaves": "Folhas de Carvalho Escuro",
  "block.minecraft.dark_oak_log": "Tronco de Carvalho Escuro",
  "block.minecraft.dark_oak_planks": "Tábuas de Carvalho Escuro",
  "block.minecraft.dark_oak_pressure_plate": "Placa de Pressão de Carvalho Escuro",
  "block.minecraft.dark_oak_sapling": "Muda de Carvalho Escuro",
  "block.minecraft.dark_oak_shelf": "Estante de Carvalho Escuro",
  "block.minecraft.dark_oak_sign": "Placa de Carvalho Escuro",
  "block.minecraft.dark_oak_slab": "Laje de Carvalho Escuro",
  "block.minecraft.dark_oak_stairs": "Escadas de Carvalho Escuro",
  "block.minecraft.dark_oak_trapdoor": "Alçapão de Carvalho Escuro",
  "block.minecraft.dark_oak_wall_hanging_sign": "Placa Suspensa de Carvalho Escuro de Parede",
  "block.minecraft.dark_oak_wall_sign": "Placa de Carvalho Escuro de Parede",
  "block.minecraft.dark_oak_wood": "Madeira de Carvalho Escuro",
  "block.minecraft.dark_prismarine": "Prismarinho Escuro",
  "block.minecraft.dark_prismarine_slab": "Laje de Prismarinho Escuro",
  "block.minecraft.dark_prismarine_stairs": "Escadas de Prismarinho Escuro",
  "block.minecraft.daylight_detector": "Detector de Luz Solar",
  "block.minecraft.dead_brain_coral": "Coral-de-Cérebro Morto",
  "block.minecraft.dead_brain_coral_block": "Bloco de Coral-de-Cérebro Morto",
  "block.minecraft.dead_brain_coral_fan": "Gorgônia-de-Cérebro Morta",
  "block.minecraft.dead_brain_coral_wall_fan": "Gorgônia-de-Cérebro Morta de Parede",
  "block.minecraft.dead_bubble_coral": "Coral-de-Bolha Morto",
  "block.minecraft.dead_bubble_coral_block": "Bloco de Coral-de-Bolha Morto",
  "block.minecraft.dead_bubble_coral_fan": "Gorgônia-de-Bolha Morta",
  "block.minecraft.dead_bubble_coral_wall_fan": "Gorgônia-de-Bolha Morta de Parede",
  "block.minecraft.dead_bush": "Arbusto Morto",
  "block.minecraft.dead_fire_coral": "Coral-de-Fogo Morto",
  "block.minecraft.dead_fire_coral_block": "Bloco de Coral-de-Fogo Morto",
  "block.minecraft.dead_fire_coral_fan": "Gorgônia-de-Fogo Morta",
  "block.minecraft.dead_fire_coral_wall_fan": "Gorgônia-de-Fogo Morta de Parede",
  "block.minecraft.dead_horn_coral": "Coral-de-Chifre Morto",
  "block.minecraft.dead_horn_coral_block": "Bloco de Coral-de-Chifre Morto",
  "block.minecraft.dead_horn_coral_fan": "Gorgônia-de-Chifre Morta",
  "block.minecraft.dead_horn_coral_wall_fan": "Gorgônia-de-Chifre Morta de Parede",
  "block.minecraft.dead_tube_coral": "Coral-de-Tubo Morto",
  "block.minecraft.dead_tube_coral_block": "Bloco de Coral-de-Tubo Morto",
  "block.minecraft.dead_tube_coral_fan": "Gorgônia-de-Tubo Morta",
  "block.minecraft.dead_tube_coral_wall_fan": "Gorgônia-de-Tubo Morta de Parede",
  "block.minecraft.decorated_pot": "Vaso Decorado",
  "block.minecraft.deepslate": "Ardosiabissal",
  "block.minecraft.deepslate_brick_slab": "Laje de Tijolos de Ardosiabissal",
  "block.minecraft.deepslate_brick_stairs": "Escadas de Tijolos de Ardosiabissal",
  "block.minecraft.deepslate_brick_wall": "Muro de Tijolos de Ardosiabissal",
  "block.minecraft.deepslate_bricks": "Tijolos de Ardosiabissal",
  "block.minecraft.deepslate_coal_ore": "Minério de Carvão de Ardosiabissal",
  "block.minecraft.deepslate_copper_ore": "Minério de Cobre de Ardosiabissal",
  "block.minecraft.deepslate_diamond_ore": "Minério de Diamante de Ardosiabissal",
  "block.minecraft.deepslate_emerald_ore": "Minério de Esmeralda de Ardosiabissal",
  "block.minecraft.deepslate_gold_ore": "Minério de Ouro de Ardosiabissal",
  "block.minecraft.deepslate_iron_ore": "Minério de Ferro de Ardosiabissal",
  "block.minecraft.deepslate_lapis_ore": "Minério de Lápis-Lazúli de Ardosiabissal",
  "block.minecraft.deepslate_redstone_ore": "Minério de Redstone de Ardosiabissal",
  "block.minecraft.deepslate_tile_slab": "Laje de Ladrilhos de Ardosiabissal",
  "block.minecraft.deepslate_tile_stairs": "Escadas de Ladrilhos de Ardosiabissal",
  "block.minecraft.deepslate_tile_wall": "Muro de Ladrilhos de Ardosiabissal",
  "block.minecraft.deepslate_tiles": "Ladrilhos de Ardosiabissal",
  "block.minecraft.detector_rail": "Trilho Detector",
  "block.minecraft.diamond_block": "Bloco de Diamante",
  "block.minecraft.diamond_ore": "Minério de Diamante",
  "block.minecraft.diorite": "Diorito",
  "block.minecraft.diorite_slab": "Laje de Diorito",
  "block.minecraft.diorite_stairs": "Escadas de Diorito",
  "block.minecraft.diorite_wall": "Muro de Diorito",
  "block.minecraft.dirt": "Terra",
  "block.minecraft.dirt_path": "Caminho de Terra",
  "block.minecraft.dispenser": "Ejetor",
  "block.minecraft.dragon_egg": "Ovo do Dragão",
  "block.minecraft.dragon_head": "Cabeça do Dragão",
  "block.minecraft.dragon_wall_head": "Cabeça do Dragão de Parede",
  "block.minecraft.dried_ghast": "Ghast Seco",
  "block.minecraft.dried_kelp_block": "Bloco de Algas Secas",
  "block.minecraft.dripstone_block": "Bloco de Espeleotema",
  "block.minecraft.dropper": "Liberador",
  "block.minecraft.emerald_block": "Bloco de Esmeralda",
  "block.minecraft.emerald_ore": "Minério de Esmeralda",
  "block.minecraft.enchanting_table": "Mesa de Encantamentos",
  "block.minecraft.end_gateway": "Passagem do End",
  "block.minecraft.end_portal": "Portal do End",
  "block.minecraft.end_portal_frame": "Moldura do Portal do End",
  "block.minecraft.end_rod": "Vara do End",
  "block.minecraft.end_stone": "Pedra do End",
  "block.minecraft.end_stone_brick_slab": "Laje de Tijolos de Pedra do End",
  "block.minecraft.end_stone_brick_stairs": "Escadas de Tijolos de Pedra do End",
  "block.minecraft.end_stone_brick_wall": "Muro de Tijolos de Pedra do End",
  "block.minecraft.end_stone_bricks": "Tijolos de Pedra do End",
  "block.minecraft.ender_chest": "Baú de Ender",
  "block.minecraft.exposed_chiseled_copper": "Cobre Talhado Exposto",
  "block.minecraft.exposed_copper": "Cobre Exposto",
  "block.minecraft.exposed_copper_bars": "Barras de Cobre Exposto",
  "block.minecraft.exposed_copper_bulb": "Lâmpada de Cobre Exposto",
  "block.minecraft.exposed_copper_chain": "Corrente de Cobre Exposto",
  "block.minecraft.exposed_copper_chest": "Baú de Cobre Exposto",
  "block.minecraft.exposed_copper_door": "Porta de Cobre Exposto",
  "block.minecraft.exposed_copper_golem_statue": "Estátua de Golem de Cobre Exposto",
  "block.minecraft.exposed_copper_grate": "Grade de Cobre Exposto",
  "block.minecraft.exposed_copper_lantern": "Lampião de Cobre Exposto",
  "block.minecraft.exposed_copper_trapdoor": "Alçapão de Cobre Exposto",
  "block.minecraft.exposed_cut_copper": "Cobre Lapidado Exposto",
  "block.minecraft.exposed_cut_copper_slab": "Laje de Cobre Lapidado Exposto",
  "block.minecraft.exposed_cut_copper_stairs": "Escadas de Cobre Lapidado Exposto",
  "block.minecraft.exposed_lightning_rod": "Para-Raios Exposto",
  "block.minecraft.farmland": "Terra Arada",
  "block.minecraft.fern": "Samambaia",
  "block.minecraft.fire": "Fogo",
  "block.minecraft.fire_coral": "Coral-de-Fogo",
  "block.minecraft.fire_coral_block": "Bloco de Coral-de-Fogo",
  "block.minecraft.fire_coral_fan": "Gorgônia-de-Fogo",
  "block.minecraft.fire_coral_wall_fan": "Gorgônia-de-Fogo de Parede",
  "block.minecraft.firefly_bush": "Arbusto-Vaga-Lume",
  "block.minecraft.fletching_table": "Bancada de Arco e Flecha",
  "block.minecraft.flower_pot": "Vaso",
  "block.minecraft.flowering_azalea": "Azaleia Florescente",
  "block.minecraft.flowering_azalea_leaves": "Folhas de Azaleia Florescente",
  "block.minecraft.frogspawn": "Ovos de Sapo",
  "block.minecraft.frosted_ice": "Gelo Fosco",
  "block.minecraft.furnace": "Fornalha",
  "block.minecraft.gilded_blackstone": "Pedra-Negra Dourada",
  "block.minecraft.glass": "Vidro",
  "block.minecraft.glass_pane": "Vidraça",
  "block.minecraft.glow_lichen": "Líquen Brilhante",
  "block.minecraft.glowstone": "Pedra Luminosa",
  "block.minecraft.gold_block": "Bloco de Ouro",
  "block.minecraft.gold_ore": "Minério de Ouro",
  "block.minecraft.golden_dandelion": "Dente-de-Leão Dourado",
  "block.minecraft.granite": "Granito",
  "block.minecraft.granite_slab": "Laje de Granito",
  "block.minecraft.granite_stairs": "Escadas de Granito",
  "block.minecraft.granite_wall": "Muro de Granito",
  "block.minecraft.grass": "Grama",
  "block.minecraft.grass_block": "Bloco de Grama",
  "block.minecraft.gravel": "Cascalho",
  "block.minecraft.gray_banner": "Estandarte Cinza",
  "block.minecraft.gray_bed": "Cama Cinza",
  "block.minecraft.gray_candle": "Vela Cinza",
  "block.minecraft.gray_candle_cake": "Bolo com Vela Cinza",
  "block.minecraft.gray_carpet": "Tapete Cinza",
  "block.minecraft.gray_concrete": "Concreto Cinza",
  "block.minecraft.gray_concrete_powder": "Cimento Cinza",
  "block.minecraft.gray_glazed_terracotta": "Azulejo Cinza",
  "block.minecraft.gray_shulker_box": "Caixa de Shulker Cinza",
  "block.minecraft.gray_stained_glass": "Vidro Cinza",
  "block.minecraft.gray_stained_glass_pane": "Vidraça Cinza",
  "block.minecraft.gray_terracotta": "Terracota Cinza",
  "block.minecraft.gray_wool": "Lã Cinza",
  "block.minecraft.green_banner": "Estandarte Verde",
  "block.minecraft.green_bed": "Cama Verde",
  "block.minecraft.green_candle": "Vela Verde",
  "block.minecraft.green_candle_cake": "Bolo com Vela Verde",
  "block.minecraft.green_carpet": "Tapete Verde",
  "block.minecraft.green_concrete": "Concreto Verde",
  "block.minecraft.green_concrete_powder": "Cimento Verde",
  "block.minecraft.green_glazed_terracotta": "Azulejo Verde",
  "block.minecraft.green_shulker_box": "Caixa de Shulker Verde",
  "block.minecraft.green_stained_glass": "Vidro Verde",
  "block.minecraft.green_stained_glass_pane": "Vidraça Verde",
  "block.minecraft.green_terracotta": "Terracota Verde",
  "block.minecraft.green_wool": "Lã Verde",
  "block.minecraft.grindstone": "Rebolo",
  "block.minecraft.hanging_roots": "Raízes Suspensas",
  "block.minecraft.hay_block": "Fardo de Feno",
  "block.minecraft.heavy_core": "Núcleo Pesado",
  "block.minecraft.heavy_weighted_pressure_plate": "Placa de Pressão de Pesagem Pesada",
  "block.minecraft.honey_block": "Bloco de Mel",
  "block.minecraft.honeycomb_block": "Bloco de Favo de Mel",
  "block.minecraft.hopper": "Funil",
  "block.minecraft.horn_coral": "Coral-de-Chifre",
  "block.minecraft.horn_coral_block": "Bloco de Coral-de-Chifre",
  "block.minecraft.horn_coral_fan": "Gorgônia-de-Chifre",
  "block.minecraft.horn_coral_wall_fan": "Gorgônia-de-Chifre de Parede",
  "block.minecraft.ice": "Gelo",
  "block.minecraft.infested_chiseled_stone_bricks": "Tijolos de Pedra Talhados Infestados",
  "block.minecraft.infested_cobblestone": "Pedregulho Infestado",
  "block.minecraft.infested_cracked_stone_bricks": "Tijolos de Pedra Rachados Infestados",
  "block.minecraft.infested_deepslate": "Ardosiabissal Infestada",
  "block.minecraft.infested_mossy_stone_bricks": "Tijolos de Pedra Musgosos Infestados",
  "block.minecraft.infested_stone": "Pedra Infestada",
  "block.minecraft.infested_stone_bricks": "Tijolos de Pedra Infestados",
  "block.minecraft.iron_bars": "Barras de Ferro",
  "block.minecraft.iron_block": "Bloco de Ferro",
  "block.minecraft.iron_chain": "Corrente de Ferro",
  "block.minecraft.iron_door": "Porta de Ferro",
  "block.minecraft.iron_ore": "Minério de Ferro",
  "block.minecraft.iron_trapdoor": "Alçapão de Ferro",
  "block.minecraft.jack_o_lantern": "Abóbora de Halloween",
  "block.minecraft.jigsaw": "Bloco-Quebra-Cabeça",
  "block.minecraft.jukebox": "Toca-Discos",
  "block.minecraft.jungle_button": "Botão da Selva",
  "block.minecraft.jungle_door": "Porta da Selva",
  "block.minecraft.jungle_fence": "Cerca da Selva",
  "block.minecraft.jungle_fence_gate": "Portão da Selva",
  "block.minecraft.jungle_hanging_sign": "Placa Suspensa da Selva",
  "block.minecraft.jungle_leaves": "Folhas da Selva",
  "block.minecraft.jungle_log": "Tronco da Selva",
  "block.minecraft.jungle_planks": "Tábuas da Selva",
  "block.minecraft.jungle_pressure_plate": "Placa de Pressão da Selva",
  "block.minecraft.jungle_sapling": "Muda da Selva",
  "block.minecraft.jungle_shelf": "Estante da Selva",
  "block.minecraft.jungle_sign": "Placa da Selva",
  "block.minecraft.jungle_slab": "Laje da Selva",
  "block.minecraft.jungle_stairs": "Escadas da Selva",
  "block.minecraft.jungle_trapdoor": "Alçapão da Selva",
  "block.minecraft.jungle_wall_hanging_sign": "Placa Suspensa da Selva de Parede",
  "block.minecraft.jungle_wall_sign": "Placa da Selva de Parede",
  "block.minecraft.jungle_wood": "Madeira da Selva",
  "block.minecraft.kelp": "Alga",
  "block.minecraft.kelp_plant": "Talo de Alga",
  "block.minecraft.ladder": "Escada de Mão",
  "block.minecraft.lantern": "Lampião",
  "block.minecraft.lapis_block": "Bloco de Lápis-Lazúli",
  "block.minecraft.lapis_ore": "Minério de Lápis-Lazúli",
  "block.minecraft.large_amethyst_bud": "Cristal de Ametista Grande",
  "block.minecraft.large_fern": "Samambaia Grande",
  "block.minecraft.lava": "Lava",
  "block.minecraft.lava_cauldron": "Caldeirão de Lava",
  "block.minecraft.leaf_litter": "Serrapilheira",
  "block.minecraft.lectern": "Atril",
  "block.minecraft.lever": "Alavanca",
  "block.minecraft.light": "Luz",
  "block.minecraft.light_blue_banner": "Estandarte Azul-Claro",
  "block.minecraft.light_blue_bed": "Cama Azul-Clara",
  "block.minecraft.light_blue_candle": "Vela Azul-Clara",
  "block.minecraft.light_blue_candle_cake": "Bolo com Vela Azul-Clara",
  "block.minecraft.light_blue_carpet": "Tapete Azul-Claro",
  "block.minecraft.light_blue_concrete": "Concreto Azul-Claro",
  "block.minecraft.light_blue_concrete_powder": "Cimento Azul-Claro",
  "block.minecraft.light_blue_glazed_terracotta": "Azulejo Azul-Claro",
  "block.minecraft.light_blue_shulker_box": "Caixa de Shulker Azul-Clara",
  "block.minecraft.light_blue_stained_glass": "Vidro Azul-Claro",
  "block.minecraft.light_blue_stained_glass_pane": "Vidraça Azul-Clara",
  "block.minecraft.light_blue_terracotta": "Terracota Azul-Clara",
  "block.minecraft.light_blue_wool": "Lã Azul-Clara",
  "block.minecraft.light_gray_banner": "Estandarte Cinza-Claro",
  "block.minecraft.light_gray_bed": "Cama Cinza-Clara",
  "block.minecraft.light_gray_candle": "Vela Cinza-Clara",
  "block.minecraft.light_gray_candle_cake": "Bolo com Vela Cinza-Clara",
  "block.minecraft.light_gray_carpet": "Tapete Cinza-Claro",
  "block.minecraft.light_gray_concrete": "Concreto Cinza-Claro",
  "block.minecraft.light_gray_concrete_powder": "Cimento Cinza-Claro",
  "block.minecraft.light_gray_glazed_terracotta": "Azulejo Cinza-Claro",
  "block.minecraft.light_gray_shulker_box": "Caixa de Shulker Cinza-Clara",
  "block.minecraft.light_gray_stained_glass": "Vidro Cinza-Claro",
  "block.minecraft.light_gray_stained_glass_pane": "Vidraça Cinza-Clara",
  "block.minecraft.light_gray_terracotta": "Terracota Cinza-Clara",
  "block.minecraft.light_gray_wool": "Lã Cinza-Clara",
  "block.minecraft.light_weighted_pressure_plate": "Placa de Pressão de Pesagem Leve",
  "block.minecraft.lightning_rod": "Para-Raios",
  "block.minecraft.lilac": "Lilás",
  "block.minecraft.lily_of_the_valley": "Lírio-do-Vale",
  "block.minecraft.lily_pad": "Vitória-Régia",
  "block.minecraft.lime_banner": "Estandarte Verde-Limão",
  "block.minecraft.lime_bed": "Cama Verde-Limão",
  "block.minecraft.lime_candle": "Vela Verde-Limão",
  "block.minecraft.lime_candle_cake": "Bolo com Vela Verde-Limão",
  "block.minecraft.lime_carpet": "Tapete Verde-Limão",
  "block.minecraft.lime_concrete": "Concreto Verde-Limão",
  "block.minecraft.lime_concrete_powder": "Cimento Verde-Limão",
  "block.minecraft.lime_glazed_terracotta": "Azulejo Verde-Limão",
  "block.minecraft.lime_shulker_box": "Caixa de Shulker Verde-Limão",
  "block.minecraft.lime_stained_glass": "Vidro Verde-Limão",
  "block.minecraft.lime_stained_glass_pane": "Vidraça Verde-Limão",
  "block.minecraft.lime_terracotta": "Terracota Verde-Limão",
  "block.minecraft.lime_wool": "Lã Verde-Limão",
  "block.minecraft.lodestone": "Magnetita",
  "block.minecraft.loom": "Tear",
  "block.minecraft.magenta_banner": "Estandarte Magenta",
  "block.minecraft.magenta_bed": "Cama Magenta",
  "block.minecraft.magenta_candle": "Vela Magenta",
  "block.minecraft.magenta_candle_cake": "Bolo com Vela Magenta",
  "block.minecraft.magenta_carpet": "Tapete Magenta",
  "block.minecraft.magenta_concrete": "Concreto Magenta",
  "block.minecraft.magenta_concrete_powder": "Cimento Magenta",
  "block.minecraft.magenta_glazed_terracotta": "Azulejo Magenta",
  "block.minecraft.magenta_shulker_box": "Caixa de Shulker Magenta",
  "block.minecraft.magenta_stained_glass": "Vidro Magenta",
  "block.minecraft.magenta_stained_glass_pane": "Vidraça Magenta",
  "block.minecraft.magenta_terracotta": "Terracota Magenta",
  "block.minecraft.magenta_wool": "Lã Magenta",
  "block.minecraft.magma_block": "Bloco de Magma",
  "block.minecraft.mangrove_button": "Botão de Mangue",
  "block.minecraft.mangrove_door": "Porta de Mangue",
  "block.minecraft.mangrove_fence": "Cerca de Mangue",
  "block.minecraft.mangrove_fence_gate": "Portão de Mangue",
  "block.minecraft.mangrove_hanging_sign": "Placa Suspensa de Mangue",
  "block.minecraft.mangrove_leaves": "Folhas de Mangue",
  "block.minecraft.mangrove_log": "Tronco de Mangue",
  "block.minecraft.mangrove_planks": "Tábuas de Mangue",
  "block.minecraft.mangrove_pressure_plate": "Placa de Pressão de Mangue",
  "block.minecraft.mangrove_propagule": "Propágulo de Mangue",
  "block.minecraft.mangrove_roots": "Raízes de Mangue",
  "block.minecraft.mangrove_shelf": "Estante de Mangue",
  "block.minecraft.mangrove_sign": "Placa de Mangue",
  "block.minecraft.mangrove_slab": "Laje de Mangue",
  "block.minecraft.mangrove_stairs": "Escadas de Mangue",
  "block.minecraft.mangrove_trapdoor": "Alçapão de Mangue",
  "block.minecraft.mangrove_wall_hanging_sign": "Placa Suspensa de Mangue de Parede",
  "block.minecraft.mangrove_wall_sign": "Placa de Mangue de Parede",
  "block.minecraft.mangrove_wood": "Madeira de Mangue",
  "block.minecraft.medium_amethyst_bud": "Cristal de Ametista Médio",
  "block.minecraft.melon": "Melancia",
  "block.minecraft.melon_stem": "Caule de Melancia",
  "block.minecraft.moss_block": "Bloco de Musgo",
  "block.minecraft.moss_carpet": "Tapete de Musgo",
  "block.minecraft.mossy_cobblestone": "Pedregulho Musgoso",
  "block.minecraft.mossy_cobblestone_slab": "Laje de Pedregulho Musgoso",
  "block.minecraft.mossy_cobblestone_stairs": "Escadas de Pedregulho Musgoso",
  "block.minecraft.mossy_cobblestone_wall": "Muro de Pedregulho Musgoso",
  "block.minecraft.mossy_stone_brick_slab": "Laje de Tijolos de Pedra Musgosos",
  "block.minecraft.mossy_stone_brick_stairs": "Escadas de Tijolos de Pedra Musgosos",
  "block.minecraft.mossy_stone_brick_wall": "Muro de Tijolos de Pedra Musgosos",
  "block.minecraft.mossy_stone_bricks": "Tijolos de Pedra Musgosos",
  "block.minecraft.moving_piston": "Pistão em Movimento",
  "block.minecraft.mud": "Barro",
  "block.minecraft.mud_brick_slab": "Laje de Tijolos de Barro",
  "block.minecraft.mud_brick_stairs": "Escadas de Tijolos de Barro",
  "block.minecraft.mud_brick_wall": "Muro de Tijolos de Barro",
  "block.minecraft.mud_bricks": "Tijolos de Barro",
  "block.minecraft.muddy_mangrove_roots": "Raízes Barrentas de Mangue",
  "block.minecraft.mushroom_stem": "Caule de Cogumelo",
  "block.minecraft.mycelium": "Micélio",
  "block.minecraft.nether_brick_fence": "Cerca de Tijolos do Nether",
  "block.minecraft.nether_brick_slab": "Laje de Tijolos do Nether",
  "block.minecraft.nether_brick_stairs": "Escadas de Tijolos do Nether",
  "block.minecraft.nether_brick_wall": "Muro de Tijolos do Nether",
  "block.minecraft.nether_bricks": "Tijolos do Nether",
  "block.minecraft.nether_gold_ore": "Minério de Ouro do Nether",
  "block.minecraft.nether_portal": "Portal do Nether",
  "block.minecraft.nether_quartz_ore": "Minério de Quartzo do Nether",
  "block.minecraft.nether_sprouts": "Brotos do Nether",
  "block.minecraft.nether_wart": "Fungo do Nether",
  "block.minecraft.nether_wart_block": "Bloco de Fungos do Nether",
  "block.minecraft.netherite_block": "Bloco de Netherita",
  "block.minecraft.netherrack": "Netherrack",
  "block.minecraft.note_block": "Bloco Musical",
  "block.minecraft.oak_button": "Botão de Carvalho",
  "block.minecraft.oak_door": "Porta de Carvalho",
  "block.minecraft.oak_fence": "Cerca de Carvalho",
  "block.minecraft.oak_fence_gate": "Portão de Carvalho",
  "block.minecraft.oak_hanging_sign": "Placa Suspensa de Carvalho",
  "block.minecraft.oak_leaves": "Folhas de Carvalho",
  "block.minecraft.oak_log": "Tronco de Carvalho",
  "block.minecraft.oak_planks": "Tábuas de Carvalho",
  "block.minecraft.oak_pressure_plate": "Placa de Pressão de Carvalho",
  "block.minecraft.oak_sapling": "Muda de Carvalho",
  "block.minecraft.oak_shelf": "Estante de Carvalho",
  "block.minecraft.oak_sign": "Placa de Carvalho",
  "block.minecraft.oak_slab": "Laje de Carvalho",
  "block.minecraft.oak_stairs": "Escadas de Carvalho",
  "block.minecraft.oak_trapdoor": "Alçapão de Carvalho",
  "block.minecraft.oak_wall_hanging_sign": "Placa Suspensa de Carvalho de Parede",
  "block.minecraft.oak_wall_sign": "Placa de Carvalho de Parede",
  "block.minecraft.oak_wood": "Madeira de Carvalho",
  "block.minecraft.observer": "Observador",
  "block.minecraft.obsidian": "Obsidiana",
  "block.minecraft.ochre_froglight": "Anfibrilho Ocre",
  "block.minecraft.ominous_banner": "Estandarte Ameaçador",
  "block.minecraft.open_eyeblossom": "Olhoquídea Aberta",
  "block.minecraft.orange_banner": "Estandarte Laranja",
  "block.minecraft.orange_bed": "Cama Laranja",
  "block.minecraft.orange_candle": "Vela Laranja",
  "block.minecraft.orange_candle_cake": "Bolo com Vela Laranja",
  "block.minecraft.orange_carpet": "Tapete Laranja",
  "block.minecraft.orange_concrete": "Concreto Laranja",
  "block.minecraft.orange_concrete_powder": "Cimento Laranja",
  "block.minecraft.orange_glazed_terracotta": "Azulejo Laranja",
  "block.minecraft.orange_shulker_box": "Caixa de Shulker Laranja",
  "block.minecraft.orange_stained_glass": "Vidro Laranja",
  "block.minecraft.orange_stained_glass_pane": "Vidraça Laranja",
  "block.minecraft.orange_terracotta": "Terracota Laranja",
  "block.minecraft.orange_tulip": "Tulipa Laranja",
  "block.minecraft.orange_wool": "Lã Laranja",
  "block.minecraft.oxeye_daisy": "Margarida",
  "block.minecraft.oxidized_chiseled_copper": "Cobre Talhado Oxidado",
  "block.minecraft.oxidized_copper": "Cobre Oxidado",
  "block.minecraft.oxidized_copper_bars": "Barras de Cobre Oxidado",
  "block.minecraft.oxidized_copper_bulb": "Lâmpada de Cobre Oxidado",
  "block.minecraft.oxidized_copper_chain": "Corrente de Cobre Oxidado",
  "block.minecraft.oxidized_copper_chest": "Baú de Cobre Oxidado",
  "block.minecraft.oxidized_copper_door": "Porta de Cobre Oxidado",
  "block.minecraft.oxidized_copper_golem_statue": "Estátua de Golem de Cobre Oxidado",
  "block.minecraft.oxidized_copper_grate": "Grade de Cobre Oxidado",
  "block.minecraft.oxidized_copper_lantern": "Lampião de Cobre Oxidado",
  "block.minecraft.oxidized_copper_trapdoor": "Alçapão de Cobre Oxidado",
  "block.minecraft.oxidized_cut_copper": "Cobre Lapidado Oxidado",
  "block.minecraft.oxidized_cut_copper_slab": "Laje de Cobre Lapidado Oxidado",
  "block.minecraft.oxidized_cut_copper_stairs": "Escadas de Cobre Lapidado Oxidado",
  "block.minecraft.oxidized_lightning_rod": "Para-Raios Oxidado",
  "block.minecraft.packed_ice": "Gelo Compactado",
  "block.minecraft.packed_mud": "Barro Seco",
  "block.minecraft.pale_hanging_moss": "Musgo Pálido Suspenso",
  "block.minecraft.pale_moss_block": "Bloco de Musgo Pálido",
  "block.minecraft.pale_moss_carpet": "Tapete de Musgo Pálido",
  "block.minecraft.pale_oak_button": "Botão de Carvalho Pálido",
  "block.minecraft.pale_oak_door": "Porta de Carvalho Pálido",
  "block.minecraft.pale_oak_fence": "Cerca de Carvalho Pálido",
  "block.minecraft.pale_oak_fence_gate": "Portão de Carvalho Pálido",
  "block.minecraft.pale_oak_hanging_sign": "Placa Suspensa de Carvalho Pálido",
  "block.minecraft.pale_oak_leaves": "Folhas de Carvalho Pálido",
  "block.minecraft.pale_oak_log": "Tronco de Carvalho Pálido",
  "block.minecraft.pale_oak_planks": "Tábuas de Carvalho Pálido",
  "block.minecraft.pale_oak_pressure_plate": "Placa de Pressão de Carvalho Pálido",
  "block.minecraft.pale_oak_sapling": "Muda de Carvalho Pálido",
  "block.minecraft.pale_oak_shelf": "Estante de Carvalho Pálido",
  "block.minecraft.pale_oak_sign": "Placa de Carvalho Pálido",
  "block.minecraft.pale_oak_slab": "Laje de Carvalho Pálido",
  "block.minecraft.pale_oak_stairs": "Escadas de Carvalho Pálido",
  "block.minecraft.pale_oak_trapdoor": "Alçapão de Carvalho Pálido",
  "block.minecraft.pale_oak_wall_hanging_sign": "Placa Suspensa de Carvalho Pálido de Parede",
  "block.minecraft.pale_oak_wall_sign": "Placa de Carvalho Pálido de Parede",
  "block.minecraft.pale_oak_wood": "Madeira de Carvalho Pálido",
  "block.minecraft.pearlescent_froglight": "Anfibrilho Perolado",
  "block.minecraft.peony": "Peônia",
  "block.minecraft.petrified_oak_slab": "Laje de Carvalho Petrificado",
  "block.minecraft.piglin_head": "Cabeça de Piglin",
  "block.minecraft.piglin_wall_head": "Cabeça de Piglin de Parede",
  "block.minecraft.pink_banner": "Estandarte Rosa",
  "block.minecraft.pink_bed": "Cama Rosa",
  "block.minecraft.pink_candle": "Vela Rosa",
  "block.minecraft.pink_candle_cake": "Bolo com Vela Rosa",
  "block.minecraft.pink_carpet": "Tapete Rosa",
  "block.minecraft.pink_concrete": "Concreto Rosa",
  "block.minecraft.pink_concrete_powder": "Cimento Rosa",
  "block.minecraft.pink_glazed_terracotta": "Azulejo Rosa",
  "block.minecraft.pink_petals": "Pétalas Rosas",
  "block.minecraft.pink_shulker_box": "Caixa de Shulker Rosa",
  "block.minecraft.pink_stained_glass": "Vidro Rosa",
  "block.minecraft.pink_stained_glass_pane": "Vidraça Rosa",
  "block.minecraft.pink_terracotta": "Terracota Rosa",
  "block.minecraft.pink_tulip": "Tulipa Rosa",
  "block.minecraft.pink_wool": "Lã Rosa",
  "block.minecraft.piston": "Pistão",
  "block.minecraft.piston_head": "Cabeça de Pistão",
  "block.minecraft.pitcher_crop": "Plantio de Planta Ancestral",
  "block.minecraft.pitcher_plant": "Planta Ancestral",
  "block.minecraft.player_head": "Cabeça de Jogador",
  "block.minecraft.player_head.named": "Cabeça de %s",
  "block.minecraft.player_wall_head": "Cabeça de Jogador de Parede",
  "block.minecraft.podzol": "Podzol",
  "block.minecraft.pointed_dripstone": "Espeleotema Pontiagudo",
  "block.minecraft.polished_andesite": "Andesito Polido",
  "block.minecraft.polished_andesite_slab": "Laje de Andesito Polido",
  "block.minecraft.polished_andesite_stairs": "Escadas de Andesito Polido",
  "block.minecraft.polished_basalt": "Basalto Polido",
  "block.minecraft.polished_blackstone": "Pedra-Negra Polida",
  "block.minecraft.polished_blackstone_brick_slab": "Laje de Tijolos de Pedra-Negra Polida",
  "block.minecraft.polished_blackstone_brick_stairs": "Escadas de Tijolos de Pedra-Negra Polida",
  "block.minecraft.polished_blackstone_brick_wall": "Muro de Tijolos de Pedra-Negra Polida",
  "block.minecraft.polished_blackstone_bricks": "Tijolos de Pedra-Negra Polida",
  "block.minecraft.polished_blackstone_button": "Botão de Pedra-Negra Polida",
  "block.minecraft.polished_blackstone_pressure_plate": "Placa de Pressão de Pedra-Negra Polida",
  "block.minecraft.polished_blackstone_slab": "Laje de Pedra-Negra Polida",
  "block.minecraft.polished_blackstone_stairs": "Escadas de Pedra-Negra Polida",
  "block.minecraft.polished_blackstone_wall": "Muro de Pedra-Negra Polida",
  "block.minecraft.polished_deepslate": "Ardosiabissal Polida",
  "block.minecraft.polished_deepslate_slab": "Laje de Ardosiabissal Polida",
  "block.minecraft.polished_deepslate_stairs": "Escadas de Ardosiabissal Polida",
  "block.minecraft.polished_deepslate_wall": "Muro de Ardosiabissal Polida",
  "block.minecraft.polished_diorite": "Diorito Polido",
  "block.minecraft.polished_diorite_slab": "Laje de Diorito Polido",
  "block.minecraft.polished_diorite_stairs": "Escadas de Diorito Polido",
  "block.minecraft.polished_granite": "Granito Polido",
  "block.minecraft.polished_granite_slab": "Laje de Granito Polido",
  "block.minecraft.polished_granite_stairs": "Escadas de Granito Polido",
  "block.minecraft.polished_tuff": "Tufo Polido",
  "block.minecraft.polished_tuff_slab": "Laje de Tufo Polido",
  "block.minecraft.polished_tuff_stairs": "Escadas de Tufo Polido",
  "block.minecraft.polished_tuff_wall": "Muro de Tufo Polido",
  "block.minecraft.poppy": "Papoula",
  "block.minecraft.potatoes": "Batatas",
  "block.minecraft.potted_acacia_sapling": "Muda de Acácia Envasada",
  "block.minecraft.potted_allium": "Alho-Silvestre Envasado",
  "block.minecraft.potted_azalea_bush": "Azaleia Envasada",
  "block.minecraft.potted_azure_bluet": "Flor-Silvestre-Azul Envasada",
  "block.minecraft.potted_bamboo": "Bambu Envasado",
  "block.minecraft.potted_birch_sapling": "Muda de Bétula Envasada",
  "block.minecraft.potted_blue_orchid": "Orquídea-Azul Envasada",
  "block.minecraft.potted_brown_mushroom": "Cogumelo Marrom Envasado",
  "block.minecraft.potted_cactus": "Cacto Envasado",
  "block.minecraft.potted_cherry_sapling": "Muda de Cerejeira Envasada",
  "block.minecraft.potted_closed_eyeblossom": "Olhoquídea Fechada Envasada",
  "block.minecraft.potted_cornflower": "Centáurea Envasada",
  "block.minecraft.potted_crimson_fungus": "Fungo Carmesim Envasado",
  "block.minecraft.potted_crimson_roots": "Raízes Carmesim Envasadas",
  "block.minecraft.potted_dandelion": "Dente-de-Leão Envasado",
  "block.minecraft.potted_dark_oak_sapling": "Muda de Carvalho Escuro Envasada",
  "block.minecraft.potted_dead_bush": "Arbusto Morto Envasado",
  "block.minecraft.potted_fern": "Samambaia Envasada",
  "block.minecraft.potted_flowering_azalea_bush": "Azaleia Florescente Envasada",
  "block.minecraft.potted_golden_dandelion": "Dente-de-Leão Dourado Envasado",
  "block.minecraft.potted_jungle_sapling": "Muda da Selva Envasada",
  "block.minecraft.potted_lily_of_the_valley": "Lírio-do-Vale Envasado",
  "block.minecraft.potted_mangrove_propagule": "Propágulo de Mangue Envasado",
  "block.minecraft.potted_oak_sapling": "Muda de Carvalho Envasada",
  "block.minecraft.potted_open_eyeblossom": "Olhoquídea Aberta Envasada",
  "block.minecraft.potted_orange_tulip": "Tulipa Laranja Envasada",
  "block.minecraft.potted_oxeye_daisy": "Margarida Envasada",
  "block.minecraft.potted_pale_oak_sapling": "Muda de Carvalho Pálido Envasada",
  "block.minecraft.potted_pink_tulip": "Tulipa Rosa Envasada",
  "block.minecraft.potted_poppy": "Papoula Envasada",
  "block.minecraft.potted_red_mushroom": "Cogumelo Vermelho Envasado",
  "block.minecraft.potted_red_tulip": "Tulipa Vermelha Envasada",
  "block.minecraft.potted_spruce_sapling": "Muda de Abeto Envasada",
  "block.minecraft.potted_torchflower": "Plantocha Envasada",
  "block.minecraft.potted_warped_fungus": "Fungo Distorcido Envasado",
  "block.minecraft.potted_warped_roots": "Raízes Distorcidas Envasadas",
  "block.minecraft.potted_white_tulip": "Tulipa Branca Envasada",
  "block.minecraft.potted_wither_rose": "Rosa do Wither Envasada",
  "block.minecraft.powder_snow": "Neve Fofa",
  "block.minecraft.powder_snow_cauldron": "Caldeirão de Neve Fofa",
  "block.minecraft.powered_rail": "Trilho Elétrico",
  "block.minecraft.prismarine": "Prismarinho",
  "block.minecraft.prismarine_brick_slab": "Laje de Tijolos de Prismarinho",
  "block.minecraft.prismarine_brick_stairs": "Escadas de Tijolos de Prismarinho",
  "block.minecraft.prismarine_bricks": "Tijolos de Prismarinho",
  "block.minecraft.prismarine_slab": "Laje de Prismarinho",
  "block.minecraft.prismarine_stairs": "Escadas de Prismarinho",
  "block.minecraft.prismarine_wall": "Muro de Prismarinho",
  "block.minecraft.pumpkin": "Abóbora",
  "block.minecraft.pumpkin_stem": "Caule de Abóbora",
  "block.minecraft.purple_banner": "Estandarte Roxo",
  "block.minecraft.purple_bed": "Cama Roxa",
  "block.minecraft.purple_candle": "Vela Roxa",
  "block.minecraft.purple_candle_cake": "Bolo com Vela Roxa",
  "block.minecraft.purple_carpet": "Tapete Roxo",
  "block.minecraft.purple_concrete": "Concreto Roxo",
  "block.minecraft.purple_concrete_powder": "Cimento Roxo",
  "block.minecraft.purple_glazed_terracotta": "Azulejo Roxo",
  "block.minecraft.purple_shulker_box": "Caixa de Shulker Roxa",
  "block.minecraft.purple_stained_glass": "Vidro Roxo",
  "block.minecraft.purple_stained_glass_pane": "Vidraça Roxa",
  "block.minecraft.purple_terracotta": "Terracota Roxa",
  "block.minecraft.purple_wool": "Lã Roxa",
  "block.minecraft.purpur_block": "Bloco de Púrpura",
  "block.minecraft.purpur_pillar": "Pilar de Púrpura",
  "block.minecraft.purpur_slab": "Laje de Púrpura",
  "block.minecraft.purpur_stairs": "Escadas de Púrpura",
  "block.minecraft.quartz_block": "Bloco de Quartzo",
  "block.minecraft.quartz_bricks": "Tijolos de Quartzo",
  "block.minecraft.quartz_pillar": "Pilar de Quartzo",
  "block.minecraft.quartz_slab": "Laje de Quartzo",
  "block.minecraft.quartz_stairs": "Escadas de Quartzo",
  "block.minecraft.rail": "Trilho",
  "block.minecraft.raw_copper_block": "Bloco de Cobre Bruto",
  "block.minecraft.raw_gold_block": "Bloco de Ouro Bruto",
  "block.minecraft.raw_iron_block": "Bloco de Ferro Bruto",
  "block.minecraft.red_banner": "Estandarte Vermelho",
  "block.minecraft.red_bed": "Cama Vermelha",
  "block.minecraft.red_candle": "Vela Vermelha",
  "block.minecraft.red_candle_cake": "Bolo com Vela Vermelha",
  "block.minecraft.red_carpet": "Tapete Vermelho",
  "block.minecraft.red_concrete": "Concreto Vermelho",
  "block.minecraft.red_concrete_powder": "Cimento Vermelho",
  "block.minecraft.red_glazed_terracotta": "Azulejo Vermelho",
  "block.minecraft.red_mushroom": "Cogumelo Vermelho",
  "block.minecraft.red_mushroom_block": "Bloco de Cogumelo Vermelho",
  "block.minecraft.red_nether_brick_slab": "Laje de Tijolos Vermelhos do Nether",
  "block.minecraft.red_nether_brick_stairs": "Escadas de Tijolos Vermelhos do Nether",
  "block.minecraft.red_nether_brick_wall": "Muro de Tijolos Vermelhos do Nether",
  "block.minecraft.red_nether_bricks": "Tijolos Vermelhos do Nether",
  "block.minecraft.red_sand": "Areia Vermelha",
  "block.minecraft.red_sandstone": "Arenito Vermelho",
  "block.minecraft.red_sandstone_slab": "Laje de Arenito Vermelho",
  "block.minecraft.red_sandstone_stairs": "Escadas de Arenito Vermelho",
  "block.minecraft.red_sandstone_wall": "Muro de Arenito Vermelho",
  "block.minecraft.red_shulker_box": "Caixa de Shulker Vermelha",
  "block.minecraft.red_stained_glass": "Vidro Vermelho",
  "block.minecraft.red_stained_glass_pane": "Vidraça Vermelha",
  "block.minecraft.red_terracotta": "Terracota Vermelha",
  "block.minecraft.red_tulip": "Tulipa Vermelha",
  "block.minecraft.red_wool": "Lã Vermelha",
  "block.minecraft.redstone_block": "Bloco de Redstone",
  "block.minecraft.redstone_lamp": "Lâmpada de Redstone",
  "block.minecraft.redstone_ore": "Minério de Redstone",
  "block.minecraft.redstone_torch": "Tocha de Redstone",
  "block.minecraft.redstone_wall_torch": "Tocha de Redstone de Parede",
  "block.minecraft.redstone_wire": "Cabo de Redstone",
  "block.minecraft.reinforced_deepslate": "Ardosiabissal Reforçada",
  "block.minecraft.repeater": "Repetidor de Redstone",
  "block.minecraft.repeating_command_block": "Bloco de Comando em Repetição",
  "block.minecraft.resin_block": "Bloco de Resina",
  "block.minecraft.resin_brick_slab": "Laje de Tijolos de Resina",
  "block.minecraft.resin_brick_stairs": "Escadas de Tijolos de Resina",
  "block.minecraft.resin_brick_wall": "Muro de Tijolos de Resina",
  "block.minecraft.resin_bricks": "Tijolos de Resina",
  "block.minecraft.resin_clump": "Agregado de Resina",
  "block.minecraft.respawn_anchor": "Âncora de Renascimento",
  "block.minecraft.rooted_dirt": "Terra Enraizada",
  "block.minecraft.rose_bush": "Roseira",
  "block.minecraft.sand": "Areia",
  "block.minecraft.sandstone": "Arenito",
  "block.minecraft.sandstone_slab": "Laje de Arenito",
  "block.minecraft.sandstone_stairs": "Escadas de Arenito",
  "block.minecraft.sandstone_wall": "Muro de Arenito",
  "block.minecraft.scaffolding": "Andaime",
  "block.minecraft.sculk": "Sculk",
  "block.minecraft.sculk_catalyst": "Catalisador de Sculk",
  "block.minecraft.sculk_sensor": "Sensor de Sculk",
  "block.minecraft.sculk_shrieker": "Emissor de Sculk",
  "block.minecraft.sculk_vein": "Veio de Sculk",
  "block.minecraft.sea_lantern": "Lanterna Marinha",
  "block.minecraft.sea_pickle": "Pepino-do-Mar",
  "block.minecraft.seagrass": "Erva Marinha",
  "block.minecraft.set_spawn": "Ponto de renascimento definido",
  "block.minecraft.short_dry_grass": "Grama Seca Baixa",
  "block.minecraft.short_grass": "Grama Baixa",
  "block.minecraft.shroomlight": "Cogubrilho",
  "block.minecraft.shulker_box": "Caixa de Shulker",
  "block.minecraft.skeleton_skull": "Crânio de Esqueleto",
  "block.minecraft.skeleton_wall_skull": "Crânio de Esqueleto de Parede",
  "block.minecraft.slime_block": "Bloco de Slime",
  "block.minecraft.small_amethyst_bud": "Cristal de Ametista Pequeno",
  "block.minecraft.small_dripleaf": "Plantaforma Pequena",
  "block.minecraft.smithing_table": "Bancada de Ferraria",
  "block.minecraft.smoker": "Defumador",
  "block.minecraft.smooth_basalt": "Basalto Liso",
  "block.minecraft.smooth_quartz": "Bloco de Quartzo Liso",
  "block.minecraft.smooth_quartz_slab": "Laje de Quartzo Liso",
  "block.minecraft.smooth_quartz_stairs": "Escadas de Quartzo Liso",
  "block.minecraft.smooth_red_sandstone": "Arenito Vermelho Liso",
  "block.minecraft.smooth_red_sandstone_slab": "Laje de Arenito Vermelho Liso",
  "block.minecraft.smooth_red_sandstone_stairs": "Escadas de Arenito Vermelho Liso",
  "block.minecraft.smooth_sandstone": "Arenito Liso",
  "block.minecraft.smooth_sandstone_slab": "Laje de Arenito Liso",
  "block.minecraft.smooth_sandstone_stairs": "Escadas de Arenito Liso",
  "block.minecraft.smooth_stone": "Pedra Lisa",
  "block.minecraft.smooth_stone_slab": "Laje de Pedra Lisa",
  "block.minecraft.sniffer_egg": "Ovo de Farejador",
  "block.minecraft.snow": "Neve",
  "block.minecraft.snow_block": "Bloco de Neve",
  "block.minecraft.soul_campfire": "Fogueira das Almas",
  "block.minecraft.soul_fire": "Fogo das Almas",
  "block.minecraft.soul_lantern": "Lampião das Almas",
  "block.minecraft.soul_sand": "Areia das Almas",
  "block.minecraft.soul_soil": "Terra das Almas",
  "block.minecraft.soul_torch": "Tocha das Almas",
  "block.minecraft.soul_wall_torch": "Tocha das Almas de Parede",
  "block.minecraft.spawn.not_valid": "Você não tem cama ou âncora de renascimento carregada, ou está obstruída",
  "block.minecraft.spawner": "Gerador de Criaturas",
  "block.minecraft.spawner.desc1": "Ao interagir com ovos geradores:",
  "block.minecraft.spawner.desc2": "Define o tipo de criatura",
  "block.minecraft.sponge": "Esponja",
  "block.minecraft.spore_blossom": "Flor de Esporos",
  "block.minecraft.spruce_button": "Botão de Abeto",
  "block.minecraft.spruce_door": "Porta de Abeto",
  "block.minecraft.spruce_fence": "Cerca de Abeto",
  "block.minecraft.spruce_fence_gate": "Portão de Abeto",
  "block.minecraft.spruce_hanging_sign": "Placa Suspensa de Abeto",
  "block.minecraft.spruce_leaves": "Folhas de Abeto",
  "block.minecraft.spruce_log": "Tronco de Abeto",
  "block.minecraft.spruce_planks": "Tábuas de Abeto",
  "block.minecraft.spruce_pressure_plate": "Placa de Pressão de Abeto",
  "block.minecraft.spruce_sapling": "Muda de Abeto",
  "block.minecraft.spruce_shelf": "Estante de Abeto",
  "block.minecraft.spruce_sign": "Placa de Abeto",
  "block.minecraft.spruce_slab": "Laje de Abeto",
  "block.minecraft.spruce_stairs": "Escadas de Abeto",
  "block.minecraft.spruce_trapdoor": "Alçapão de Abeto",
  "block.minecraft.spruce_wall_hanging_sign": "Placa Suspensa de Abeto de Parede",
  "block.minecraft.spruce_wall_sign": "Placa de Abeto de Parede",
  "block.minecraft.spruce_wood": "Madeira de Abeto",
  "block.minecraft.sticky_piston": "Pistão Grudento",
  "block.minecraft.stone": "Pedra",
  "block.minecraft.stone_brick_slab": "Laje de Tijolos de Pedra",
  "block.minecraft.stone_brick_stairs": "Escadas de Tijolos de Pedra",
  "block.minecraft.stone_brick_wall": "Muro de Tijolos de Pedra",
  "block.minecraft.stone_bricks": "Tijolos de Pedra",
  "block.minecraft.stone_button": "Botão de Pedra",
  "block.minecraft.stone_pressure_plate": "Placa de Pressão de Pedra",
  "block.minecraft.stone_slab": "Laje de Pedra",
  "block.minecraft.stone_stairs": "Escadas de Pedra",
  "block.minecraft.stonecutter": "Cortador de Pedras",
  "block.minecraft.stripped_acacia_log": "Tronco de Acácia Descascado",
  "block.minecraft.stripped_acacia_wood": "Madeira de Acácia Descascada",
  "block.minecraft.stripped_bamboo_block": "Bloco de Bambu Descascado",
  "block.minecraft.stripped_birch_log": "Tronco de Bétula Descascado",
  "block.minecraft.stripped_birch_wood": "Madeira de Bétula Descascada",
  "block.minecraft.stripped_cherry_log": "Tronco de Cerejeira Descascado",
  "block.minecraft.stripped_cherry_wood": "Madeira de Cerejeira Descascada",
  "block.minecraft.stripped_crimson_hyphae": "Hifas Carmesim Descascadas",
  "block.minecraft.stripped_crimson_stem": "Caule Carmesim Descascado",
  "block.minecraft.stripped_dark_oak_log": "Tronco de Carvalho Escuro Descascado",
  "block.minecraft.stripped_dark_oak_wood": "Madeira de Carvalho Escuro Descascada",
  "block.minecraft.stripped_jungle_log": "Tronco da Selva Descascado",
  "block.minecraft.stripped_jungle_wood": "Madeira da Selva Descascada",
  "block.minecraft.stripped_mangrove_log": "Tronco de Mangue Descascado",
  "block.minecraft.stripped_mangrove_wood": "Madeira de Mangue Descascada",
  "block.minecraft.stripped_oak_log": "Tronco de Carvalho Descascado",
  "block.minecraft.stripped_oak_wood": "Madeira de Carvalho Descascada",
  "block.minecraft.stripped_pale_oak_log": "Tronco de Carvalho Pálido Descascado",
  "block.minecraft.stripped_pale_oak_wood": "Madeira de Carvalho Pálido Descascada",
  "block.minecraft.stripped_spruce_log": "Tronco de Abeto Descascado",
  "block.minecraft.stripped_spruce_wood": "Madeira de Abeto Descascada",
  "block.minecraft.stripped_warped_hyphae": "Hifas Distorcidas Descascadas",
  "block.minecraft.stripped_warped_stem": "Caule Distorcido Descascado",
  "block.minecraft.structure_block": "Gerador de Estruturas",
  "block.minecraft.structure_void": "Vazio Estrutural",
  "block.minecraft.sugar_cane": "Cana-de-Açúcar",
  "block.minecraft.sunflower": "Girassol",
  "block.minecraft.suspicious_gravel": "Cascalho Suspeito",
  "block.minecraft.suspicious_sand": "Areia Suspeita",
  "block.minecraft.sweet_berry_bush": "Arbusto de Bagas Doces",
  "block.minecraft.tall_dry_grass": "Grama Seca Alta",
  "block.minecraft.tall_grass": "Grama Alta",
  "block.minecraft.tall_seagrass": "Erva Marinha Alta",
  "block.minecraft.target": "Alvo",
  "block.minecraft.terracotta": "Terracota",
  "block.minecraft.test_block": "Bloco de Teste",
  "block.minecraft.test_instance_block": "Bloco de Instância de Teste",
  "block.minecraft.tinted_glass": "Vidro Fosco",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "Explosões de TNT são desativadas",
  "block.minecraft.torch": "Tocha",
  "block.minecraft.torchflower": "Plantocha",
  "block.minecraft.torchflower_crop": "Plantio de Plantocha",
  "block.minecraft.trapped_chest": "Baú com Armadilha",
  "block.minecraft.trial_spawner": "Gerador do Desafio",
  "block.minecraft.tripwire": "Fio de Armadilha",
  "block.minecraft.tripwire_hook": "Gancho de Armadilha",
  "block.minecraft.tube_coral": "Coral-de-Tubo",
  "block.minecraft.tube_coral_block": "Bloco de Coral-de-Tubo",
  "block.minecraft.tube_coral_fan": "Gorgônia-de-Tubo",
  "block.minecraft.tube_coral_wall_fan": "Gorgônia-de-Tubo de Parede",
  "block.minecraft.tuff": "Tufo",
  "block.minecraft.tuff_brick_slab": "Laje de Tijolos de Tufo",
  "block.minecraft.tuff_brick_stairs": "Escadas de Tijolos de Tufo",
  "block.minecraft.tuff_brick_wall": "Muro de Tijolos de Tufo",
  "block.minecraft.tuff_bricks": "Tijolos de Tufo",
  "block.minecraft.tuff_slab": "Laje de Tufo",
  "block.minecraft.tuff_stairs": "Escadas de Tufo",
  "block.minecraft.tuff_wall": "Muro de Tufo",
  "block.minecraft.turtle_egg": "Ovo de Tartaruga",
  "block.minecraft.twisting_vines": "Trepadeiras Retorcidas",
  "block.minecraft.twisting_vines_plant": "Planta de Trepadeiras Retorcidas",
  "block.minecraft.vault": "Cofre",
  "block.minecraft.verdant_froglight": "Anfibrilho Verdejante",
  "block.minecraft.vine": "Trepadeiras",
  "block.minecraft.void_air": "Ar do Vazio",
  "block.minecraft.wall_torch": "Tocha de Parede",
  "block.minecraft.warped_button": "Botão Distorcido",
  "block.minecraft.warped_door": "Porta Distorcida",
  "block.minecraft.warped_fence": "Cerca Distorcida",
  "block.minecraft.warped_fence_gate": "Portão Distorcido",
  "block.minecraft.warped_fungus": "Fungo Distorcido",
  "block.minecraft.warped_hanging_sign": "Placa Suspensa Distorcida",
  "block.minecraft.warped_hyphae": "Hifas Distorcidas",
  "block.minecraft.warped_nylium": "Nicélio Distorcido",
  "block.minecraft.warped_planks": "Tábuas Distorcidas",
  "block.minecraft.warped_pressure_plate": "Placa de Pressão Distorcida",
  "block.minecraft.warped_roots": "Raízes Distorcidas",
  "block.minecraft.warped_shelf": "Estante Distorcida",
  "block.minecraft.warped_sign": "Placa Distorcida",
  "block.minecraft.warped_slab": "Laje Distorcida",
  "block.minecraft.warped_stairs": "Escadas Distorcidas",
  "block.minecraft.warped_stem": "Caule Distorcido",
  "block.minecraft.warped_trapdoor": "Alçapão Distorcido",
  "block.minecraft.warped_wall_hanging_sign": "Placa Suspensa Distorcida de Parede",
  "block.minecraft.warped_wall_sign": "Placa Distorcida de Parede",
  "block.minecraft.warped_wart_block": "Bloco de Fungos Distorcidos",
  "block.minecraft.water": "Água",
  "block.minecraft.water_cauldron": "Caldeirão de Água",
  "block.minecraft.waxed_chiseled_copper": "Cobre Talhado Encerado",
  "block.minecraft.waxed_copper_bars": "Barras de Cobre Encerado",
  "block.minecraft.waxed_copper_block": "Bloco de Cobre Encerado",
  "block.minecraft.waxed_copper_bulb": "Lâmpada de Cobre Encerado",
  "block.minecraft.waxed_copper_chain": "Corrente de Cobre Encerado",
  "block.minecraft.waxed_copper_chest": "Baú de Cobre Encerado",
  "block.minecraft.waxed_copper_door": "Porta de Cobre Encerado",
  "block.minecraft.waxed_copper_golem_statue": "Estátua de Golem de Cobre Encerado",
  "block.minecraft.waxed_copper_grate": "Grade de Cobre Encerado",
  "block.minecraft.waxed_copper_lantern": "Lampião de Cobre Encerado",
  "block.minecraft.waxed_copper_trapdoor": "Alçapão de Cobre Encerado",
  "block.minecraft.waxed_cut_copper": "Cobre Lapidado Encerado",
  "block.minecraft.waxed_cut_copper_slab": "Laje de Cobre Lapidado Encerado",
  "block.minecraft.waxed_cut_copper_stairs": "Escadas de Cobre Lapidado Encerado",
  "block.minecraft.waxed_exposed_chiseled_copper": "Cobre Talhado Exposto Encerado",
  "block.minecraft.waxed_exposed_copper": "Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_bars": "Barras de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_bulb": "Lâmpada de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_chain": "Corrente de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_chest": "Baú de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_door": "Porta de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_golem_statue": "Estátua de Golem de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_grate": "Grade de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_lantern": "Lampião de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_copper_trapdoor": "Alçapão de Cobre Exposto Encerado",
  "block.minecraft.waxed_exposed_cut_copper": "Cobre Lapidado Exposto Encerado",
  "block.minecraft.waxed_exposed_cut_copper_slab": "Laje de Cobre Lapidado Exposto Encerado",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "Escadas de Cobre Lapidado Exposto Encerado",
  "block.minecraft.waxed_exposed_lightning_rod": "Para-Raios Exposto Encerado",
  "block.minecraft.waxed_lightning_rod": "Para-Raios Encerado",
  "block.minecraft.waxed_oxidized_chiseled_copper": "Cobre Talhado Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper": "Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_bars": "Barras de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_bulb": "Lâmpada de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_chain": "Corrente de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_chest": "Baú de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_door": "Porta de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "Estátua de Golem de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_grate": "Grade de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_lantern": "Lampião de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "Alçapão de Cobre Oxidado Encerado",
  "block.minecraft.waxed_oxidized_cut_copper": "Cobre Lapidado Oxidado Encerado",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "Laje de Cobre Lapidado Oxidado Encerado",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "Escadas de Cobre Lapidado Oxidado Encerado",
  "block.minecraft.waxed_oxidized_lightning_rod": "Para-Raios Oxidado Encerado",
  "block.minecraft.waxed_weathered_chiseled_copper": "Cobre Talhado Desgastado Encerado",
  "block.minecraft.waxed_weathered_copper": "Cobre Desgastado Encerado",
  "block.minecraft.waxed_weathered_copper_bars": "Barras de Cobre Desgastado Encerado",
  "block.minecraft.waxed_weathered_copper_bulb": "Lâmpada de Cobre Desgastado Encerado",
  "block.minecraft.waxed_weathered_copper_chain": "Corrente de Cobre Desgastado Encerado",
  "block.minecraft.waxed_weathered_copper_chest": "Baú de Cobre Desgastado Encerado",
  "block.minecraft.waxed_weathered_copper_door": "Porta de Cobre Desgastado Encerado",
  "block.minecraft.waxed_weathered_copper_golem_statue": "Estátua de Golem de Cobre Desgastado Encerado",
  "block.minecraft.waxed_weathered_copper_grate": "Grade de Cobre Desgastado Encerado",
  "block.minecraft.waxed_weathered_copper_lantern": "Lampião de Cobre Desgastado Encerado",
  "block.minecraft.waxed_weathered_copper_trapdoor": "Alçapão de Cobre Desgastado Encerado",
  "block.minecraft.waxed_weathered_cut_copper": "Cobre Lapidado Desgastado Encerado",
  "block.minecraft.waxed_weathered_cut_copper_slab": "Laje de Cobre Lapidado Desgastado Encerado",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "Escadas de Cobre Lapidado Desgastado Encerado",
  "block.minecraft.waxed_weathered_lightning_rod": "Para-Raios Desgastado Encerado",
  "block.minecraft.weathered_chiseled_copper": "Cobre Talhado Desgastado",
  "block.minecraft.weathered_copper": "Cobre Desgastado",
  "block.minecraft.weathered_copper_bars": "Barras de Cobre Desgastado",
  "block.minecraft.weathered_copper_bulb": "Lâmpada de Cobre Desgastado",
  "block.minecraft.weathered_copper_chain": "Corrente de Cobre Desgastado",
  "block.minecraft.weathered_copper_chest": "Baú de Cobre Desgastado",
  "block.minecraft.weathered_copper_door": "Porta de Cobre Desgastado",
  "block.minecraft.weathered_copper_golem_statue": "Estátua de Golem de Cobre Desgastado",
  "block.minecraft.weathered_copper_grate": "Grade de Cobre Desgastado",
  "block.minecraft.weathered_copper_lantern": "Lampião de Cobre Desgastado",
  "block.minecraft.weathered_copper_trapdoor": "Alçapão de Cobre Desgastado",
  "block.minecraft.weathered_cut_copper": "Cobre Lapidado Desgastado",
  "block.minecraft.weathered_cut_copper_slab": "Laje de Cobre Lapidado Desgastado",
  "block.minecraft.weathered_cut_copper_stairs": "Escadas de Cobre Lapidado Desgastado",
  "block.minecraft.weathered_lightning_rod": "Para-Raios Desgastado",
  "block.minecraft.weeping_vines": "Trepadeiras Choronas",
  "block.minecraft.weeping_vines_plant": "Planta de Trepadeiras Choronas",
  "block.minecraft.wet_sponge": "Esponja Úmida",
  "block.minecraft.wheat": "Plantio de Trigo",
  "block.minecraft.white_banner": "Estandarte Branco",
  "block.minecraft.white_bed": "Cama Branca",
  "block.minecraft.white_candle": "Vela Branca",
  "block.minecraft.white_candle_cake": "Bolo com Vela Branca",
  "block.minecraft.white_carpet": "Tapete Branco",
  "block.minecraft.white_concrete": "Concreto Branco",
  "block.minecraft.white_concrete_powder": "Cimento Branco",
  "block.minecraft.white_glazed_terracotta": "Azulejo Branco",
  "block.minecraft.white_shulker_box": "Caixa de Shulker Branca",
  "block.minecraft.white_stained_glass": "Vidro Branco",
  "block.minecraft.white_stained_glass_pane": "Vidraça Branca",
  "block.minecraft.white_terracotta": "Terracota Branca",
  "block.minecraft.white_tulip": "Tulipa Branca",
  "block.minecraft.white_wool": "Lã Branca",
  "block.minecraft.wildflowers": "Flores-do-Campo",
  "block.minecraft.wither_rose": "Rosa do Wither",
  "block.minecraft.wither_skeleton_skull": "Crânio de Esqueleto Wither",
  "block.minecraft.wither_skeleton_wall_skull": "Crânio de Esqueleto Wither de Parede",
  "block.minecraft.yellow_banner": "Estandarte Amarelo",
  "block.minecraft.yellow_bed": "Cama Amarela",
  "block.minecraft.yellow_candle": "Vela Amarela",
  "block.minecraft.yellow_candle_cake": "Bolo com Vela Amarela",
  "block.minecraft.yellow_carpet": "Tapete Amarelo",
  "block.minecraft.yellow_concrete": "Concreto Amarelo",
  "block.minecraft.yellow_concrete_powder": "Cimento Amarelo",
  "block.minecraft.yellow_glazed_terracotta": "Azulejo Amarelo",
  "block.minecraft.yellow_shulker_box": "Caixa de Shulker Amarela",
  "block.minecraft.yellow_stained_glass": "Vidro Amarelo",
  "block.minecraft.yellow_stained_glass_pane": "Vidraça Amarela",
  "block.minecraft.yellow_terracotta": "Terracota Amarela",
  "block.minecraft.yellow_wool": "Lã Amarela",
  "block.minecraft.zombie_head": "Cabeça de Zumbi",
  "block.minecraft.zombie_wall_head": "Cabeça de Zumbi de Parede",
  "item.minecraft.acacia_boat": "Bote de Acácia",
  "item.minecraft.acacia_chest_boat": "Bote de Acácia com Baú",
  "item.minecraft.allay_spawn_egg": "Ovo Gerador de Allay",
  "item.minecraft.amethyst_shard": "Fragmento de Ametista",
  "item.minecraft.angler_pottery_shard": "Óstraco de Pesca",
  "item.minecraft.angler_pottery_sherd": "Óstraco de Pesca",
  "item.minecraft.apple": "Maçã",
  "item.minecraft.archer_pottery_shard": "Óstraco de Arco",
  "item.minecraft.archer_pottery_sherd": "Óstraco de Arco",
  "item.minecraft.armadillo_scute": "Escama de Tatu",
  "item.minecraft.armadillo_spawn_egg": "Ovo Gerador de Tatu",
  "item.minecraft.armor_stand": "Suporte de Armaduras",
  "item.minecraft.arms_up_pottery_shard": "Óstraco de Figura",
  "item.minecraft.arms_up_pottery_sherd": "Óstraco de Figura",
  "item.minecraft.arrow": "Flecha",
  "item.minecraft.axolotl_bucket": "Balde com Axolote",
  "item.minecraft.axolotl_spawn_egg": "Ovo Gerador de Axolote",
  "item.minecraft.baked_potato": "Batata Assada",
  "item.minecraft.bamboo_chest_raft": "Jangada de Bambu com Baú",
  "item.minecraft.bamboo_raft": "Jangada de Bambu",
  "item.minecraft.bat_spawn_egg": "Ovo Gerador de Morcego",
  "item.minecraft.bee_spawn_egg": "Ovo Gerador de Abelha",
  "item.minecraft.beef": "Bife Cru",
  "item.minecraft.beetroot": "Beterraba",
  "item.minecraft.beetroot_seeds": "Sementes de Beterraba",
  "item.minecraft.beetroot_soup": "Ensopado de Beterraba",
  "item.minecraft.birch_boat": "Bote de Bétula",
  "item.minecraft.birch_chest_boat": "Bote de Bétula com Baú",
  "item.minecraft.black_bundle": "Trouxa Preta",
  "item.minecraft.black_dye": "Corante Preto",
  "item.minecraft.black_harness": "Arreio Preto",
  "item.minecraft.blade_pottery_shard": "Óstraco de Espada",
  "item.minecraft.blade_pottery_sherd": "Óstraco de Espada",
  "item.minecraft.blaze_powder": "Pó de Blaze",
  "item.minecraft.blaze_rod": "Vara de Blaze",
  "item.minecraft.blaze_spawn_egg": "Ovo Gerador de Blaze",
  "item.minecraft.blue_bundle": "Trouxa Azul",
  "item.minecraft.blue_dye": "Corante Azul",
  "item.minecraft.blue_egg": "Ovo Azul",
  "item.minecraft.blue_harness": "Arreio Azul",
  "item.minecraft.bogged_spawn_egg": "Ovo Gerador de Pantanoso",
  "item.minecraft.bolt_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "Enfeite de Parafuso",
  "item.minecraft.bone": "Osso",
  "item.minecraft.bone_meal": "Farinha de Osso",
  "item.minecraft.book": "Livro",
  "item.minecraft.bordure_indented_banner_pattern": "Figura para Estandarte de Bordadura Dentada",
  "item.minecraft.bow": "Arco",
  "item.minecraft.bowl": "Tigela",
  "item.minecraft.bread": "Pão",
  "item.minecraft.breeze_rod": "Vara de Vórtice",
  "item.minecraft.breeze_spawn_egg": "Ovo Gerador de Vórtice",
  "item.minecraft.brewer_pottery_shard": "Óstraco de Poção",
  "item.minecraft.brewer_pottery_sherd": "Óstraco de Poção",
  "item.minecraft.brewing_stand": "Suporte de Poções",
  "item.minecraft.brick": "Tijolo",
  "item.minecraft.brown_bundle": "Trouxa Marrom",
  "item.minecraft.brown_dye": "Corante Marrom",
  "item.minecraft.brown_egg": "Ovo Marrom",
  "item.minecraft.brown_harness": "Arreio Marrom",
  "item.minecraft.brush": "Pincel",
  "item.minecraft.bucket": "Balde",
  "item.minecraft.bundle": "Trouxa",
  "item.minecraft.bundle.empty": "Vazia",
  "item.minecraft.bundle.empty.description": "Pode carregar um conjunto diverso de itens",
  "item.minecraft.bundle.full": "Cheia",
  "item.minecraft.bundle.fullness": "%s/%s",
  "item.minecraft.burn_pottery_shard": "Óstraco de Fogo",
  "item.minecraft.burn_pottery_sherd": "Óstraco de Fogo",
  "item.minecraft.camel_husk_spawn_egg": "Ovo Gerador de Camelo-Múmia",
  "item.minecraft.camel_spawn_egg": "Ovo Gerador de Camelo",
  "item.minecraft.carrot": "Cenoura",
  "item.minecraft.carrot_on_a_stick": "Vara com Cenoura",
  "item.minecraft.cat_spawn_egg": "Ovo Gerador de Gato",
  "item.minecraft.cauldron": "Caldeirão",
  "item.minecraft.cave_spider_spawn_egg": "Ovo Gerador de Aranha das Cavernas",
  "item.minecraft.chainmail_boots": "Botas de Malha",
  "item.minecraft.chainmail_chestplate": "Peitoral de Malha",
  "item.minecraft.chainmail_helmet": "Capacete de Malha",
  "item.minecraft.chainmail_leggings": "Calças de Malha",
  "item.minecraft.charcoal": "Carvão Vegetal",
  "item.minecraft.cherry_boat": "Bote de Cerejeira",
  "item.minecraft.cherry_chest_boat": "Bote de Cerejeira com Baú",
  "item.minecraft.chest_minecart": "Carrinho de Mina com Baú",
  "item.minecraft.chicken": "Frango Cru",
  "item.minecraft.chicken_spawn_egg": "Ovo Gerador de Galinha",
  "item.minecraft.chorus_fruit": "Fruta do Coro",
  "item.minecraft.clay_ball": "Bola de Argila",
  "item.minecraft.clock": "Relógio",
  "item.minecraft.coal": "Carvão",
  "item.minecraft.coast_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.coast_armor_trim_smithing_template.new": "Enfeite do Litoral",
  "item.minecraft.cocoa_beans": "Sementes de Cacau",
  "item.minecraft.cod": "Bacalhau Cru",
  "item.minecraft.cod_bucket": "Balde com Bacalhau",
  "item.minecraft.cod_spawn_egg": "Ovo Gerador de Bacalhau",
  "item.minecraft.command_block_minecart": "Carrinho de Mina com Bloco de Comando",
  "item.minecraft.compass": "Bússola",
  "item.minecraft.cooked_beef": "Filé",
  "item.minecraft.cooked_chicken": "Frango Assado",
  "item.minecraft.cooked_cod": "Bacalhau Assado",
  "item.minecraft.cooked_mutton": "Carneiro Assado",
  "item.minecraft.cooked_porkchop": "Costeleta de Porco Assada",
  "item.minecraft.cooked_rabbit": "Coelho Assado",
  "item.minecraft.cooked_salmon": "Salmão Assado",
  "item.minecraft.cookie": "Biscoito",
  "item.minecraft.copper_axe": "Machado de Cobre",
  "item.minecraft.copper_boots": "Botas de Cobre",
  "item.minecraft.copper_chestplate": "Peitoral de Cobre",
  "item.minecraft.copper_golem_spawn_egg": "Ovo Gerador de Golem de Cobre",
  "item.minecraft.copper_helmet": "Capacete de Cobre",
  "item.minecraft.copper_hoe": "Enxada de Cobre",
  "item.minecraft.copper_horse_armor": "Armadura de Cobre para Cavalo",
  "item.minecraft.copper_ingot": "Lingote de Cobre",
  "item.minecraft.copper_leggings": "Calças de Cobre",
  "item.minecraft.copper_nautilus_armor": "Armadura de Cobre para Náutilo",
  "item.minecraft.copper_nugget": "Pepita de Cobre",
  "item.minecraft.copper_pickaxe": "Picareta de Cobre",
  "item.minecraft.copper_shovel": "Pá de Cobre",
  "item.minecraft.copper_spear": "Lança de Cobre",
  "item.minecraft.copper_sword": "Espada de Cobre",
  "item.minecraft.cow_spawn_egg": "Ovo Gerador de Vaca",
  "item.minecraft.creaking_spawn_egg": "Ovo Gerador de Rangente",
  "item.minecraft.creeper_banner_pattern": "Figura para Estandarte",
  "item.minecraft.creeper_banner_pattern.desc": "Figura de Creeper",
  "item.minecraft.creeper_banner_pattern.new": "Figura para Estandarte de Creeper",
  "item.minecraft.creeper_spawn_egg": "Ovo Gerador de Creeper",
  "item.minecraft.crossbow": "Besta",
  "item.minecraft.crossbow.projectile": "Projétil:",
  "item.minecraft.crossbow.projectile.multiple": "Projétil: %s x %s",
  "item.minecraft.crossbow.projectile.single": "Projétil: %s",
  "item.minecraft.cyan_bundle": "Trouxa Ciano",
  "item.minecraft.cyan_dye": "Corante Ciano",
  "item.minecraft.cyan_harness": "Arreio Ciano",
  "item.minecraft.danger_pottery_shard": "Óstraco de Creeper",
  "item.minecraft.danger_pottery_sherd": "Óstraco de Creeper",
  "item.minecraft.dark_oak_boat": "Bote de Carvalho Escuro",
  "item.minecraft.dark_oak_chest_boat": "Bote de Carvalho Escuro com Baú",
  "item.minecraft.debug_stick": "Graveto de Depuração",
  "item.minecraft.debug_stick.empty": "%s não tem propriedades",
  "item.minecraft.debug_stick.select": "selecionou \"%s\" (%s)",
  "item.minecraft.debug_stick.update": "\"%s\" foi alterado para %s",
  "item.minecraft.diamond": "Diamante",
  "item.minecraft.diamond_axe": "Machado de Diamante",
  "item.minecraft.diamond_boots": "Botas de Diamante",
  "item.minecraft.diamond_chestplate": "Peitoral de Diamante",
  "item.minecraft.diamond_helmet": "Capacete de Diamante",
  "item.minecraft.diamond_hoe": "Enxada de Diamante",
  "item.minecraft.diamond_horse_armor": "Armadura de Diamante para Cavalo",
  "item.minecraft.diamond_leggings": "Calças de Diamante",
  "item.minecraft.diamond_nautilus_armor": "Armadura de Diamante para Náutilo",
  "item.minecraft.diamond_pickaxe": "Picareta de Diamante",
  "item.minecraft.diamond_shovel": "Pá de Diamante",
  "item.minecraft.diamond_spear": "Lança de Diamante",
  "item.minecraft.diamond_sword": "Espada de Diamante",
  "item.minecraft.disc_fragment_5": "Fragmento de Disco",
  "item.minecraft.disc_fragment_5.desc": "Disco Musical — 5",
  "item.minecraft.dolphin_spawn_egg": "Ovo Gerador de Golfinho",
  "item.minecraft.donkey_spawn_egg": "Ovo Gerador de Burro",
  "item.minecraft.dragon_breath": "Bafo do Dragão",
  "item.minecraft.dried_kelp": "Algas Secas",
  "item.minecraft.drowned_spawn_egg": "Ovo Gerador de Afogado",
  "item.minecraft.dune_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.dune_armor_trim_smithing_template.new": "Enfeite de Dunas",
  "item.minecraft.echo_shard": "Fragmento de Eco",
  "item.minecraft.egg": "Ovo",
  "item.minecraft.elder_guardian_spawn_egg": "Ovo Gerador de Guardião-Mestre",
  "item.minecraft.elytra": "Élitros",
  "item.minecraft.emerald": "Esmeralda",
  "item.minecraft.enchanted_book": "Livro Encantado",
  "item.minecraft.enchanted_golden_apple": "Maçã Dourada Encantada",
  "item.minecraft.end_crystal": "Cristal do End",
  "item.minecraft.ender_dragon_spawn_egg": "Ovo Gerador do Dragão Ender",
  "item.minecraft.ender_eye": "Olho de Ender",
  "item.minecraft.ender_pearl": "Pérola de Ender",
  "item.minecraft.enderman_spawn_egg": "Ovo Gerador de Enderman",
  "item.minecraft.endermite_spawn_egg": "Ovo Gerador de Endermite",
  "item.minecraft.evoker_spawn_egg": "Ovo Gerador de Invocador",
  "item.minecraft.experience_bottle": "Frasco de Experiência",
  "item.minecraft.explorer_pottery_shard": "Óstraco de Mapa",
  "item.minecraft.explorer_pottery_sherd": "Óstraco de Mapa",
  "item.minecraft.eye_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.eye_armor_trim_smithing_template.new": "Enfeite de Olho",
  "item.minecraft.feather": "Pena",
  "item.minecraft.fermented_spider_eye": "Olho de Aranha Fermentado",
  "item.minecraft.field_masoned_banner_pattern": "Figura para Estandarte de Muro",
  "item.minecraft.filled_map": "Mapa",
  "item.minecraft.fire_charge": "Bola de Fogo",
  "item.minecraft.firework_rocket": "Fogo de Artifício",
  "item.minecraft.firework_rocket.flight": "Duração do voo:",
  "item.minecraft.firework_rocket.multiple_stars": "%s x %s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "Estrela de Fogo de Artifício",
  "item.minecraft.firework_star.black": "preta",
  "item.minecraft.firework_star.blue": "azul",
  "item.minecraft.firework_star.brown": "marrom",
  "item.minecraft.firework_star.custom_color": "personalizada",
  "item.minecraft.firework_star.cyan": "ciano",
  "item.minecraft.firework_star.fade_to": "Explosão",
  "item.minecraft.firework_star.flicker": "cintilante",
  "item.minecraft.firework_star.gray": "cinza",
  "item.minecraft.firework_star.green": "verde",
  "item.minecraft.firework_star.light_blue": "azul-clara",
  "item.minecraft.firework_star.light_gray": "cinza-clara",
  "item.minecraft.firework_star.lime": "verde-limão",
  "item.minecraft.firework_star.magenta": "magenta",
  "item.minecraft.firework_star.orange": "laranja",
  "item.minecraft.firework_star.pink": "rosa",
  "item.minecraft.firework_star.purple": "roxa",
  "item.minecraft.firework_star.red": "vermelha",
  "item.minecraft.firework_star.shape": "Formato desconhecido",
  "item.minecraft.firework_star.shape.burst": "Estouro",
  "item.minecraft.firework_star.shape.creeper": "Formato de Creeper",
  "item.minecraft.firework_star.shape.large_ball": "Esfera grande",
  "item.minecraft.firework_star.shape.small_ball": "Esfera pequena",
  "item.minecraft.firework_star.shape.star": "Formato de estrela",
  "item.minecraft.firework_star.trail": "com feixe de luz",
  "item.minecraft.firework_star.white": "branca",
  "item.minecraft.firework_star.yellow": "amarela",
  "item.minecraft.fishing_rod": "Vara de Pesca",
  "item.minecraft.flint": "Sílex",
  "item.minecraft.flint_and_steel": "Pederneira",
  "item.minecraft.flow_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.flow_armor_trim_smithing_template.new": "Enfeite de Fluxo",
  "item.minecraft.flow_banner_pattern": "Figura para Estandarte",
  "item.minecraft.flow_banner_pattern.desc": "Espiral",
  "item.minecraft.flow_banner_pattern.new": "Figura para Estandarte de Espiral",
  "item.minecraft.flow_pottery_sherd": "Óstraco de Fluxo",
  "item.minecraft.flower_banner_pattern": "Figura para Estandarte",
  "item.minecraft.flower_banner_pattern.desc": "Figura de Flor",
  "item.minecraft.flower_banner_pattern.new": "Figura para Estandarte de Flor",
  "item.minecraft.flower_pot": "Vaso",
  "item.minecraft.fox_spawn_egg": "Ovo Gerador de Raposa",
  "item.minecraft.friend_pottery_shard": "Óstraco de Amigo",
  "item.minecraft.friend_pottery_sherd": "Óstraco de Amigo",
  "item.minecraft.frog_spawn_egg": "Ovo Gerador de Sapo",
  "item.minecraft.furnace_minecart": "Carrinho de Mina com Fornalha",
  "item.minecraft.ghast_spawn_egg": "Ovo Gerador de Ghast",
  "item.minecraft.ghast_tear": "Lágrima de Ghast",
  "item.minecraft.glass_bottle": "Frasco de Vidro",
  "item.minecraft.glistering_melon_slice": "Fatia de Melancia Reluzente",
  "item.minecraft.globe_banner_pattern": "Figura para Estandarte",
  "item.minecraft.globe_banner_pattern.desc": "Globo",
  "item.minecraft.globe_banner_pattern.new": "Figura para Estandarte de Globo",
  "item.minecraft.glow_berries": "Bagas Brilhantes",
  "item.minecraft.glow_ink_sac": "Bolsa de Tinta Brilhante",
  "item.minecraft.glow_item_frame": "Moldura Brilhante",
  "item.minecraft.glow_squid_spawn_egg": "Ovo Gerador de Lula-Brilhante",
  "item.minecraft.glowstone_dust": "Pó de Pedra Luminosa",
  "item.minecraft.goat_horn": "Chifre de Cabra",
  "item.minecraft.goat_spawn_egg": "Ovo Gerador de Cabra",
  "item.minecraft.gold_ingot": "Lingote de Ouro",
  "item.minecraft.gold_nugget": "Pepita de Ouro",
  "item.minecraft.golden_apple": "Maçã Dourada",
  "item.minecraft.golden_axe": "Machado de Ouro",
  "item.minecraft.golden_boots": "Botas de Ouro",
  "item.minecraft.golden_carrot": "Cenoura Dourada",
  "item.minecraft.golden_chestplate": "Peitoral de Ouro",
  "item.minecraft.golden_helmet": "Capacete de Ouro",
  "item.minecraft.golden_hoe": "Enxada de Ouro",
  "item.minecraft.golden_horse_armor": "Armadura de Ouro para Cavalo",
  "item.minecraft.golden_leggings": "Calças de Ouro",
  "item.minecraft.golden_nautilus_armor": "Armadura de Ouro para Náutilo",
  "item.minecraft.golden_pickaxe": "Picareta de Ouro",
  "item.minecraft.golden_shovel": "Pá de Ouro",
  "item.minecraft.golden_spear": "Lança de Ouro",
  "item.minecraft.golden_sword": "Espada de Ouro",
  "item.minecraft.gray_bundle": "Trouxa Cinza",
  "item.minecraft.gray_dye": "Corante Cinza",
  "item.minecraft.gray_harness": "Arreio Cinza",
  "item.minecraft.green_bundle": "Trouxa Verde",
  "item.minecraft.green_dye": "Corante Verde",
  "item.minecraft.green_harness": "Arreio Verde",
  "item.minecraft.guardian_spawn_egg": "Ovo Gerador de Guardião",
  "item.minecraft.gunpowder": "Pólvora",
  "item.minecraft.guster_banner_pattern": "Figura para Estandarte",
  "item.minecraft.guster_banner_pattern.desc": "Vórtice",
  "item.minecraft.guster_banner_pattern.new": "Figura para Estandarte de Vórtice",
  "item.minecraft.guster_pottery_sherd": "Óstraco de Vórtice",
  "item.minecraft.happy_ghast_spawn_egg": "Ovo Gerador de Ghast Feliz",
  "item.minecraft.harness": "Arreio",
  "item.minecraft.heart_of_the_sea": "Coração do Mar",
  "item.minecraft.heart_pottery_shard": "Óstraco de Coração",
  "item.minecraft.heart_pottery_sherd": "Óstraco de Coração",
  "item.minecraft.heartbreak_pottery_shard": "Óstraco de Coração Partido",
  "item.minecraft.heartbreak_pottery_sherd": "Óstraco de Coração Partido",
  "item.minecraft.hoglin_spawn_egg": "Ovo Gerador de Hoglin",
  "item.minecraft.honey_bottle": "Frasco de Mel",
  "item.minecraft.honeycomb": "Favo de Mel",
  "item.minecraft.hopper_minecart": "Carrinho de Mina com Funil",
  "item.minecraft.horse_spawn_egg": "Ovo Gerador de Cavalo",
  "item.minecraft.host_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.host_armor_trim_smithing_template.new": "Enfeite de Hospedeiro",
  "item.minecraft.howl_pottery_shard": "Óstraco de Lobo",
  "item.minecraft.howl_pottery_sherd": "Óstraco de Lobo",
  "item.minecraft.husk_spawn_egg": "Ovo Gerador de Zumbi-Múmia",
  "item.minecraft.ink_sac": "Bolsa de Tinta",
  "item.minecraft.iron_axe": "Machado de Ferro",
  "item.minecraft.iron_boots": "Botas de Ferro",
  "item.minecraft.iron_chestplate": "Peitoral de Ferro",
  "item.minecraft.iron_golem_spawn_egg": "Ovo Gerador de Golem de Ferro",
  "item.minecraft.iron_helmet": "Capacete de Ferro",
  "item.minecraft.iron_hoe": "Enxada de Ferro",
  "item.minecraft.iron_horse_armor": "Armadura de Ferro para Cavalo",
  "item.minecraft.iron_ingot": "Lingote de Ferro",
  "item.minecraft.iron_leggings": "Calças de Ferro",
  "item.minecraft.iron_nautilus_armor": "Armadura de Ferro para Náutilo",
  "item.minecraft.iron_nugget": "Pepita de Ferro",
  "item.minecraft.iron_pickaxe": "Picareta de Ferro",
  "item.minecraft.iron_shovel": "Pá de Ferro",
  "item.minecraft.iron_spear": "Lança de Ferro",
  "item.minecraft.iron_sword": "Espada de Ferro",
  "item.minecraft.item_frame": "Moldura",
  "item.minecraft.jungle_boat": "Bote da Selva",
  "item.minecraft.jungle_chest_boat": "Bote da Selva com Baú",
  "item.minecraft.knowledge_book": "Enciclopédia",
  "item.minecraft.lapis_lazuli": "Lápis-Lazúli",
  "item.minecraft.lava_bucket": "Balde de Lava",
  "item.minecraft.lead": "Laço",
  "item.minecraft.leather": "Couro",
  "item.minecraft.leather_boots": "Botas de Couro",
  "item.minecraft.leather_chestplate": "Túnica de Couro",
  "item.minecraft.leather_helmet": "Capuz de Couro",
  "item.minecraft.leather_horse_armor": "Armadura de Couro para Cavalo",
  "item.minecraft.leather_leggings": "Calças de Couro",
  "item.minecraft.light_blue_bundle": "Trouxa Azul-Clara",
  "item.minecraft.light_blue_dye": "Corante Azul-Claro",
  "item.minecraft.light_blue_harness": "Arreio Azul-Claro",
  "item.minecraft.light_gray_bundle": "Trouxa Cinza-Clara",
  "item.minecraft.light_gray_dye": "Corante Cinza-Claro",
  "item.minecraft.light_gray_harness": "Arreio Cinza-Claro",
  "item.minecraft.lime_bundle": "Trouxa Verde-Limão",
  "item.minecraft.lime_dye": "Corante Verde-Limão",
  "item.minecraft.lime_harness": "Arreio Verde-Limão",
  "item.minecraft.lingering_potion": "Poção Prolongada",
  "item.minecraft.lingering_potion.effect.awkward": "Poção Prolongada Estranha",
  "item.minecraft.lingering_potion.effect.empty": "Poção Prolongada Não Fabricável",
  "item.minecraft.lingering_potion.effect.fire_resistance": "Poção Prolongada de Resistência ao Fogo",
  "item.minecraft.lingering_potion.effect.harming": "Poção Prolongada de Dano",
  "item.minecraft.lingering_potion.effect.healing": "Poção Prolongada de Cura",
  "item.minecraft.lingering_potion.effect.infested": "Poção Prolongada de Infestação",
  "item.minecraft.lingering_potion.effect.invisibility": "Poção Prolongada de Invisibilidade",
  "item.minecraft.lingering_potion.effect.leaping": "Poção Prolongada de Salto",
  "item.minecraft.lingering_potion.effect.levitation": "Poção Prolongada de Levitação",
  "item.minecraft.lingering_potion.effect.luck": "Poção Prolongada de Sorte",
  "item.minecraft.lingering_potion.effect.mundane": "Poção Prolongada Comum",
  "item.minecraft.lingering_potion.effect.night_vision": "Poção Prolongada de Visão Noturna",
  "item.minecraft.lingering_potion.effect.oozing": "Poção Prolongada Pegajosa",
  "item.minecraft.lingering_potion.effect.poison": "Poção Prolongada de Veneno",
  "item.minecraft.lingering_potion.effect.regeneration": "Poção Prolongada de Regeneração",
  "item.minecraft.lingering_potion.effect.slow_falling": "Poção Prolongada de Queda Lenta",
  "item.minecraft.lingering_potion.effect.slowness": "Poção Prolongada de Lentidão",
  "item.minecraft.lingering_potion.effect.strength": "Poção Prolongada de Força",
  "item.minecraft.lingering_potion.effect.swiftness": "Poção Prolongada de Agilidade",
  "item.minecraft.lingering_potion.effect.thick": "Poção Prolongada Espessa",
  "item.minecraft.lingering_potion.effect.turtle_master": "Poção Prolongada do Mestre-Tartaruga",
  "item.minecraft.lingering_potion.effect.water": "Frasco de Água Prolongado",
  "item.minecraft.lingering_potion.effect.water_breathing": "Poção Prolongada de Respiração Aquática",
  "item.minecraft.lingering_potion.effect.weakness": "Poção Prolongada de Fraqueza",
  "item.minecraft.lingering_potion.effect.weaving": "Poção Prolongada de Tecitura",
  "item.minecraft.lingering_potion.effect.wind_charged": "Poção Prolongada de Ventania",
  "item.minecraft.llama_spawn_egg": "Ovo Gerador de Lhama",
  "item.minecraft.lodestone_compass": "Bússola Magnetizada",
  "item.minecraft.mace": "Maça",
  "item.minecraft.magenta_bundle": "Trouxa Magenta",
  "item.minecraft.magenta_dye": "Corante Magenta",
  "item.minecraft.magenta_harness": "Arreio Magenta",
  "item.minecraft.magma_cream": "Creme de Magma",
  "item.minecraft.magma_cube_spawn_egg": "Ovo Gerador de Cubo de Magma",
  "item.minecraft.mangrove_boat": "Bote de Mangue",
  "item.minecraft.mangrove_chest_boat": "Bote de Mangue com Baú",
  "item.minecraft.map": "Mapa em Branco",
  "item.minecraft.melon_seeds": "Sementes de Melancia",
  "item.minecraft.melon_slice": "Fatia de Melancia",
  "item.minecraft.milk_bucket": "Balde de Leite",
  "item.minecraft.minecart": "Carrinho de Mina",
  "item.minecraft.miner_pottery_shard": "Óstraco de Picareta",
  "item.minecraft.miner_pottery_sherd": "Óstraco de Picareta",
  "item.minecraft.mojang_banner_pattern": "Figura para Estandarte",
  "item.minecraft.mojang_banner_pattern.desc": "Símbolo",
  "item.minecraft.mojang_banner_pattern.new": "Figura para Estandarte de Emblema",
  "item.minecraft.mooshroom_spawn_egg": "Ovo Gerador de Mooshroom",
  "item.minecraft.mourner_pottery_shard": "Óstraco de Defensor",
  "item.minecraft.mourner_pottery_sherd": "Óstraco de Defensor",
  "item.minecraft.mule_spawn_egg": "Ovo Gerador de Mula",
  "item.minecraft.mushroom_stew": "Ensopado de Cogumelos",
  "item.minecraft.music_disc_11": "Disco Musical",
  "item.minecraft.music_disc_11.desc": "C418 — 11",
  "item.minecraft.music_disc_13": "Disco Musical",
  "item.minecraft.music_disc_13.desc": "C418 — 13",
  "item.minecraft.music_disc_5": "Disco Musical",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg — 5",
  "item.minecraft.music_disc_blocks": "Disco Musical",
  "item.minecraft.music_disc_blocks.desc": "C418 — blocks",
  "item.minecraft.music_disc_cat": "Disco Musical",
  "item.minecraft.music_disc_cat.desc": "C418 — cat",
  "item.minecraft.music_disc_chirp": "Disco Musical",
  "item.minecraft.music_disc_chirp.desc": "C418 — chirp",
  "item.minecraft.music_disc_creator": "Disco Musical",
  "item.minecraft.music_disc_creator.desc": "Lena Raine — Creator",
  "item.minecraft.music_disc_creator_music_box": "Disco Musical",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine — Creator (Caixa Musical)",
  "item.minecraft.music_disc_far": "Disco Musical",
  "item.minecraft.music_disc_far.desc": "C418 — far",
  "item.minecraft.music_disc_lava_chicken": "Disco Musical",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions — Lava Chicken",
  "item.minecraft.music_disc_mall": "Disco Musical",
  "item.minecraft.music_disc_mall.desc": "C418 — mall",
  "item.minecraft.music_disc_mellohi": "Disco Musical",
  "item.minecraft.music_disc_mellohi.desc": "C418 — mellohi",
  "item.minecraft.music_disc_otherside": "Disco Musical",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine — otherside",
  "item.minecraft.music_disc_pigstep": "Disco Musical",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine — Pigstep",
  "item.minecraft.music_disc_precipice": "Disco Musical",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof — Precipice",
  "item.minecraft.music_disc_relic": "Disco Musical",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof — Relic",
  "item.minecraft.music_disc_stal": "Disco Musical",
  "item.minecraft.music_disc_stal.desc": "C418 — stal",
  "item.minecraft.music_disc_strad": "Disco Musical",
  "item.minecraft.music_disc_strad.desc": "C418 — strad",
  "item.minecraft.music_disc_tears": "Disco Musical",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy — Tears",
  "item.minecraft.music_disc_wait": "Disco Musical",
  "item.minecraft.music_disc_wait.desc": "C418 — wait",
  "item.minecraft.music_disc_ward": "Disco Musical",
  "item.minecraft.music_disc_ward.desc": "C418 — ward",
  "item.minecraft.mutton": "Carneiro Cru",
  "item.minecraft.name_tag": "Etiqueta",
  "item.minecraft.nautilus_shell": "Concha de Náutilo",
  "item.minecraft.nautilus_spawn_egg": "Ovo Gerador de Náutilo",
  "item.minecraft.nether_brick": "Tijolo do Nether",
  "item.minecraft.nether_star": "Estrela do Nether",
  "item.minecraft.nether_wart": "Fungo do Nether",
  "item.minecraft.netherite_axe": "Machado de Netherita",
  "item.minecraft.netherite_boots": "Botas de Netherita",
  "item.minecraft.netherite_chestplate": "Peitoral de Netherita",
  "item.minecraft.netherite_helmet": "Capacete de Netherita",
  "item.minecraft.netherite_hoe": "Enxada de Netherita",
  "item.minecraft.netherite_horse_armor": "Armadura de Netherita para Cavalo",
  "item.minecraft.netherite_ingot": "Lingote de Netherita",
  "item.minecraft.netherite_leggings": "Calças de Netherita",
  "item.minecraft.netherite_nautilus_armor": "Armadura de Netherita para Náutilo",
  "item.minecraft.netherite_pickaxe": "Picareta de Netherita",
  "item.minecraft.netherite_scrap": "Fragmentos de Netherita",
  "item.minecraft.netherite_shovel": "Pá de Netherita",
  "item.minecraft.netherite_spear": "Lança de Netherita",
  "item.minecraft.netherite_sword": "Espada de Netherita",
  "item.minecraft.netherite_upgrade_smithing_template": "Molde de Ferraria",
  "item.minecraft.netherite_upgrade_smithing_template.new": "Melhoria de Netherita",
  "item.minecraft.oak_boat": "Bote de Carvalho",
  "item.minecraft.oak_chest_boat": "Bote de Carvalho com Baú",
  "item.minecraft.ocelot_spawn_egg": "Ovo Gerador de Jaguatirica",
  "item.minecraft.ominous_bottle": "Frasco Sombrio",
  "item.minecraft.ominous_trial_key": "Chave Sombria do Desafio",
  "item.minecraft.orange_bundle": "Trouxa Laranja",
  "item.minecraft.orange_dye": "Corante Laranja",
  "item.minecraft.orange_harness": "Arreio Laranja",
  "item.minecraft.painting": "Quadro",
  "item.minecraft.pale_oak_boat": "Bote de Carvalho Pálido",
  "item.minecraft.pale_oak_chest_boat": "Bote de Carvalho Pálido com Baú",
  "item.minecraft.panda_spawn_egg": "Ovo Gerador de Panda",
  "item.minecraft.paper": "Papel",
  "item.minecraft.parched_spawn_egg": "Ovo Gerador de Ressecado",
  "item.minecraft.parrot_spawn_egg": "Ovo Gerador de Papagaio",
  "item.minecraft.phantom_membrane": "Membrana de Espectro",
  "item.minecraft.phantom_spawn_egg": "Ovo Gerador de Espectro",
  "item.minecraft.pig_spawn_egg": "Ovo Gerador de Porco",
  "item.minecraft.piglin_banner_pattern": "Figura para Estandarte",
  "item.minecraft.piglin_banner_pattern.desc": "Focinho",
  "item.minecraft.piglin_banner_pattern.new": "Figura para Estandarte de Focinho",
  "item.minecraft.piglin_brute_spawn_egg": "Ovo Gerador de Piglin Bárbaro",
  "item.minecraft.piglin_spawn_egg": "Ovo Gerador de Piglin",
  "item.minecraft.pillager_spawn_egg": "Ovo Gerador de Saqueador",
  "item.minecraft.pink_bundle": "Trouxa Rosa",
  "item.minecraft.pink_dye": "Corante Rosa",
  "item.minecraft.pink_harness": "Arreio Rosa",
  "item.minecraft.pitcher_plant": "Planta Ancestral",
  "item.minecraft.pitcher_pod": "Vagem de Planta Ancestral",
  "item.minecraft.plenty_pottery_shard": "Óstraco de Baú",
  "item.minecraft.plenty_pottery_sherd": "Óstraco de Baú",
  "item.minecraft.poisonous_potato": "Batata Venenosa",
  "item.minecraft.polar_bear_spawn_egg": "Ovo Gerador de Urso-Polar",
  "item.minecraft.popped_chorus_fruit": "Fruta do Coro Cozida",
  "item.minecraft.porkchop": "Costeleta de Porco Crua",
  "item.minecraft.potato": "Batata",
  "item.minecraft.potion": "Poção",
  "item.minecraft.potion.effect.awkward": "Poção Estranha",
  "item.minecraft.potion.effect.empty": "Poção Não Fabricável",
  "item.minecraft.potion.effect.fire_resistance": "Poção de Resistência ao Fogo",
  "item.minecraft.potion.effect.harming": "Poção de Dano",
  "item.minecraft.potion.effect.healing": "Poção de Cura",
  "item.minecraft.potion.effect.infested": "Poção de Infestação",
  "item.minecraft.potion.effect.invisibility": "Poção de Invisibilidade",
  "item.minecraft.potion.effect.leaping": "Poção de Salto",
  "item.minecraft.potion.effect.levitation": "Poção de Levitação",
  "item.minecraft.potion.effect.luck": "Poção de Sorte",
  "item.minecraft.potion.effect.mundane": "Poção Comum",
  "item.minecraft.potion.effect.night_vision": "Poção de Visão Noturna",
  "item.minecraft.potion.effect.oozing": "Poção Pegajosa",
  "item.minecraft.potion.effect.poison": "Poção de Veneno",
  "item.minecraft.potion.effect.regeneration": "Poção de Regeneração",
  "item.minecraft.potion.effect.slow_falling": "Poção de Queda Lenta",
  "item.minecraft.potion.effect.slowness": "Poção de Lentidão",
  "item.minecraft.potion.effect.strength": "Poção de Força",
  "item.minecraft.potion.effect.swiftness": "Poção de Agilidade",
  "item.minecraft.potion.effect.thick": "Poção Espessa",
  "item.minecraft.potion.effect.turtle_master": "Poção do Mestre-Tartaruga",
  "item.minecraft.potion.effect.water": "Frasco de Água",
  "item.minecraft.potion.effect.water_breathing": "Poção de Respiração Aquática",
  "item.minecraft.potion.effect.weakness": "Poção de Fraqueza",
  "item.minecraft.potion.effect.weaving": "Poção de Tecitura",
  "item.minecraft.potion.effect.wind_charged": "Poção de Ventania",
  "item.minecraft.pottery_shard_archer": "Óstraco de Arco",
  "item.minecraft.pottery_shard_arms_up": "Óstraco de Figura",
  "item.minecraft.pottery_shard_prize": "Óstraco de Joia",
  "item.minecraft.pottery_shard_skull": "Óstraco de Caveira",
  "item.minecraft.powder_snow_bucket": "Balde de Neve Fofa",
  "item.minecraft.prismarine_crystals": "Cristais de Prismarinho",
  "item.minecraft.prismarine_shard": "Pedaço de Prismarinho",
  "item.minecraft.prize_pottery_shard": "Óstraco de Joia",
  "item.minecraft.prize_pottery_sherd": "Óstraco de Joia",
  "item.minecraft.pufferfish": "Baiacu",
  "item.minecraft.pufferfish_bucket": "Balde com Baiacu",
  "item.minecraft.pufferfish_spawn_egg": "Ovo Gerador de Baiacu",
  "item.minecraft.pumpkin_pie": "Torta de Abóbora",
  "item.minecraft.pumpkin_seeds": "Sementes de Abóbora",
  "item.minecraft.purple_bundle": "Trouxa Roxa",
  "item.minecraft.purple_dye": "Corante Roxo",
  "item.minecraft.purple_harness": "Arreio Roxo",
  "item.minecraft.quartz": "Quartzo do Nether",
  "item.minecraft.rabbit": "Coelho Cru",
  "item.minecraft.rabbit_foot": "Pé de Coelho",
  "item.minecraft.rabbit_hide": "Pele de Coelho",
  "item.minecraft.rabbit_spawn_egg": "Ovo Gerador de Coelho",
  "item.minecraft.rabbit_stew": "Ensopado de Coelho",
  "item.minecraft.raiser_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "Enfeite de Levante",
  "item.minecraft.ravager_spawn_egg": "Ovo Gerador de Devastador",
  "item.minecraft.raw_copper": "Cobre Bruto",
  "item.minecraft.raw_gold": "Ouro Bruto",
  "item.minecraft.raw_iron": "Ferro Bruto",
  "item.minecraft.recovery_compass": "Bússola de Retomada",
  "item.minecraft.red_bundle": "Trouxa Vermelha",
  "item.minecraft.red_dye": "Corante Vermelho",
  "item.minecraft.red_harness": "Arreio Vermelho",
  "item.minecraft.redstone": "Pó de Redstone",
  "item.minecraft.resin_brick": "Tijolo de Resina",
  "item.minecraft.resin_clump": "Agregado de Resina",
  "item.minecraft.rib_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.rib_armor_trim_smithing_template.new": "Enfeite de Costelas",
  "item.minecraft.rotten_flesh": "Carne Podre",
  "item.minecraft.saddle": "Sela",
  "item.minecraft.salmon": "Salmão Cru",
  "item.minecraft.salmon_bucket": "Balde com Salmão",
  "item.minecraft.salmon_spawn_egg": "Ovo Gerador de Salmão",
  "item.minecraft.scrape_pottery_sherd": "Óstraco de Machado",
  "item.minecraft.scute": "Escama",
  "item.minecraft.sentry_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "Enfeite de Sentinela",
  "item.minecraft.shaper_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "Enfeite de Moldador",
  "item.minecraft.sheaf_pottery_shard": "Óstraco de Trigo",
  "item.minecraft.sheaf_pottery_sherd": "Óstraco de Trigo",
  "item.minecraft.shears": "Tesoura",
  "item.minecraft.sheep_spawn_egg": "Ovo Gerador de Ovelha",
  "item.minecraft.shelter_pottery_shard": "Óstraco de Árvore",
  "item.minecraft.shelter_pottery_sherd": "Óstraco de Árvore",
  "item.minecraft.shield": "Escudo",
  "item.minecraft.shield.black": "Escudo Preto",
  "item.minecraft.shield.blue": "Escudo Azul",
  "item.minecraft.shield.brown": "Escudo Marrom",
  "item.minecraft.shield.cyan": "Escudo Ciano",
  "item.minecraft.shield.gray": "Escudo Cinza",
  "item.minecraft.shield.green": "Escudo Verde",
  "item.minecraft.shield.light_blue": "Escudo Azul-Claro",
  "item.minecraft.shield.light_gray": "Escudo Cinza-Claro",
  "item.minecraft.shield.lime": "Escudo Verde-Limão",
  "item.minecraft.shield.magenta": "Escudo Magenta",
  "item.minecraft.shield.orange": "Escudo Laranja",
  "item.minecraft.shield.pink": "Escudo Rosa",
  "item.minecraft.shield.purple": "Escudo Roxo",
  "item.minecraft.shield.red": "Escudo Vermelho",
  "item.minecraft.shield.white": "Escudo Branco",
  "item.minecraft.shield.yellow": "Escudo Amarelo",
  "item.minecraft.shulker_shell": "Casco de Shulker",
  "item.minecraft.shulker_spawn_egg": "Ovo Gerador de Shulker",
  "item.minecraft.sign": "Placa",
  "item.minecraft.silence_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.silence_armor_trim_smithing_template.new": "Enfeite de Silêncio",
  "item.minecraft.silverfish_spawn_egg": "Ovo Gerador de Traça",
  "item.minecraft.skeleton_horse_spawn_egg": "Ovo Gerador de Cavalo-Esqueleto",
  "item.minecraft.skeleton_spawn_egg": "Ovo Gerador de Esqueleto",
  "item.minecraft.skull_banner_pattern": "Figura para Estandarte",
  "item.minecraft.skull_banner_pattern.desc": "Figura de Caveira",
  "item.minecraft.skull_banner_pattern.new": "Figura para Estandarte de Caveira",
  "item.minecraft.skull_pottery_shard": "Óstraco de Caveira",
  "item.minecraft.skull_pottery_sherd": "Óstraco de Caveira",
  "item.minecraft.slime_ball": "Bola de Slime",
  "item.minecraft.slime_spawn_egg": "Ovo Gerador de Slime",
  "item.minecraft.smithing_template": "Molde de Ferraria",
  "item.minecraft.smithing_template.applies_to": "Aplicável em:",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "Adicione um lingote ou cristal",
  "item.minecraft.smithing_template.armor_trim.applies_to": "Armadura",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "Adicione uma peça de armadura",
  "item.minecraft.smithing_template.armor_trim.ingredients": "Lingotes e cristais",
  "item.minecraft.smithing_template.ingredients": "Ingredientes:",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "Adicione um Lingote de Netherita",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "Equipamento de Diamante",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "Adicione uma ferramenta, arma ou armadura de Diamante",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "Lingote de Netherita",
  "item.minecraft.smithing_template.upgrade": "Melhorias: ",
  "item.minecraft.sniffer_spawn_egg": "Ovo Gerador de Farejador",
  "item.minecraft.snort_pottery_shard": "Óstraco de Farejador",
  "item.minecraft.snort_pottery_sherd": "Óstraco de Farejador",
  "item.minecraft.snout_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.snout_armor_trim_smithing_template.new": "Enfeite de Focinho",
  "item.minecraft.snow_golem_spawn_egg": "Ovo Gerador de Golem de Neve",
  "item.minecraft.snowball": "Bola de Neve",
  "item.minecraft.spectral_arrow": "Flecha Espectral",
  "item.minecraft.spider_eye": "Olho de Aranha",
  "item.minecraft.spider_spawn_egg": "Ovo Gerador de Aranha",
  "item.minecraft.spire_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.spire_armor_trim_smithing_template.new": "Enfeite de Espiral",
  "item.minecraft.splash_potion": "Poção Arremessável",
  "item.minecraft.splash_potion.effect.awkward": "Poção Arremessável Estranha",
  "item.minecraft.splash_potion.effect.empty": "Poção Arremessável Não Fabricável",
  "item.minecraft.splash_potion.effect.fire_resistance": "Poção Arremessável de Resistência ao Fogo",
  "item.minecraft.splash_potion.effect.harming": "Poção Arremessável de Dano",
  "item.minecraft.splash_potion.effect.healing": "Poção Arremessável de Cura",
  "item.minecraft.splash_potion.effect.infested": "Poção Arremessável de Infestação",
  "item.minecraft.splash_potion.effect.invisibility": "Poção Arremessável de Invisibilidade",
  "item.minecraft.splash_potion.effect.leaping": "Poção Arremessável de Salto",
  "item.minecraft.splash_potion.effect.levitation": "Poção Arremessável de Levitação",
  "item.minecraft.splash_potion.effect.luck": "Poção Arremessável de Sorte",
  "item.minecraft.splash_potion.effect.mundane": "Poção Arremessável Comum",
  "item.minecraft.splash_potion.effect.night_vision": "Poção Arremessável de Visão Noturna",
  "item.minecraft.splash_potion.effect.oozing": "Poção Arremessável Pegajosa",
  "item.minecraft.splash_potion.effect.poison": "Poção Arremessável de Veneno",
  "item.minecraft.splash_potion.effect.regeneration": "Poção Arremessável de Regeneração",
  "item.minecraft.splash_potion.effect.slow_falling": "Poção Arremessável de Queda Lenta",
  "item.minecraft.splash_potion.effect.slowness": "Poção Arremessável de Lentidão",
  "item.minecraft.splash_potion.effect.strength": "Poção Arremessável de Força",
  "item.minecraft.splash_potion.effect.swiftness": "Poção Arremessável de Agilidade",
  "item.minecraft.splash_potion.effect.thick": "Poção Arremessável Espessa",
  "item.minecraft.splash_potion.effect.turtle_master": "Poção Arremessável do Mestre-Tartaruga",
  "item.minecraft.splash_potion.effect.water": "Frasco de Água Arremessável",
  "item.minecraft.splash_potion.effect.water_breathing": "Poção Arremessável de Respiração Aquática",
  "item.minecraft.splash_potion.effect.weakness": "Poção Arremessável de Fraqueza",
  "item.minecraft.splash_potion.effect.weaving": "Poção Arremessável de Tecitura",
  "item.minecraft.splash_potion.effect.wind_charged": "Poção Arremessável de Ventania",
  "item.minecraft.spruce_boat": "Bote de Abeto",
  "item.minecraft.spruce_chest_boat": "Bote de Abeto com Baú",
  "item.minecraft.spyglass": "Luneta",
  "item.minecraft.squid_spawn_egg": "Ovo Gerador de Lula",
  "item.minecraft.stick": "Graveto",
  "item.minecraft.stone_axe": "Machado de Pedra",
  "item.minecraft.stone_hoe": "Enxada de Pedra",
  "item.minecraft.stone_pickaxe": "Picareta de Pedra",
  "item.minecraft.stone_shovel": "Pá de Pedra",
  "item.minecraft.stone_spear": "Lança de Pedra",
  "item.minecraft.stone_sword": "Espada de Pedra",
  "item.minecraft.stray_spawn_egg": "Ovo Gerador de Errante",
  "item.minecraft.strider_spawn_egg": "Ovo Gerador de Lavagante",
  "item.minecraft.string": "Linha",
  "item.minecraft.sugar": "Açúcar",
  "item.minecraft.suspicious_stew": "Ensopado Suspeito",
  "item.minecraft.sweet_berries": "Bagas Doces",
  "item.minecraft.tadpole_bucket": "Balde com Girino",
  "item.minecraft.tadpole_spawn_egg": "Ovo Gerador de Girino",
  "item.minecraft.tide_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.tide_armor_trim_smithing_template.new": "Enfeite de Marés",
  "item.minecraft.tipped_arrow": "Flecha com Efeito",
  "item.minecraft.tipped_arrow.effect.awkward": "Flecha com Efeito",
  "item.minecraft.tipped_arrow.effect.empty": "Flecha com Efeito Não Fabricável",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "Flecha de Resistência ao Fogo",
  "item.minecraft.tipped_arrow.effect.harming": "Flecha de Dano",
  "item.minecraft.tipped_arrow.effect.healing": "Flecha de Cura",
  "item.minecraft.tipped_arrow.effect.infested": "Flecha de Infestação",
  "item.minecraft.tipped_arrow.effect.invisibility": "Flecha de Invisibilidade",
  "item.minecraft.tipped_arrow.effect.leaping": "Flecha de Salto",
  "item.minecraft.tipped_arrow.effect.levitation": "Flecha de Levitação",
  "item.minecraft.tipped_arrow.effect.luck": "Flecha de Sorte",
  "item.minecraft.tipped_arrow.effect.mundane": "Flecha com Efeito",
  "item.minecraft.tipped_arrow.effect.night_vision": "Flecha de Visão Noturna",
  "item.minecraft.tipped_arrow.effect.oozing": "Flecha Pegajosa",
  "item.minecraft.tipped_arrow.effect.poison": "Flecha de Veneno",
  "item.minecraft.tipped_arrow.effect.regeneration": "Flecha de Regeneração",
  "item.minecraft.tipped_arrow.effect.slow_falling": "Flecha de Queda Lenta",
  "item.minecraft.tipped_arrow.effect.slowness": "Flecha de Lentidão",
  "item.minecraft.tipped_arrow.effect.strength": "Flecha de Força",
  "item.minecraft.tipped_arrow.effect.swiftness": "Flecha de Agilidade",
  "item.minecraft.tipped_arrow.effect.thick": "Flecha com Efeito",
  "item.minecraft.tipped_arrow.effect.turtle_master": "Flecha do Mestre-Tartaruga",
  "item.minecraft.tipped_arrow.effect.water": "Flecha sem Efeito",
  "item.minecraft.tipped_arrow.effect.water_breathing": "Flecha de Respiração Aquática",
  "item.minecraft.tipped_arrow.effect.weakness": "Flecha de Fraqueza",
  "item.minecraft.tipped_arrow.effect.weaving": "Flecha de Tecitura",
  "item.minecraft.tipped_arrow.effect.wind_charged": "Flecha de Ventania",
  "item.minecraft.tnt_minecart": "Carrinho de Mina com TNT",
  "item.minecraft.torchflower_seeds": "Sementes de Plantocha",
  "item.minecraft.totem_of_undying": "Totem da Imortalidade",
  "item.minecraft.trader_llama_spawn_egg": "Ovo Gerador de Lhama do Vendedor",
  "item.minecraft.trial_key": "Chave do Desafio",
  "item.minecraft.trident": "Tridente",
  "item.minecraft.tropical_fish": "Peixe Tropical",
  "item.minecraft.tropical_fish_bucket": "Balde com Peixe Tropical",
  "item.minecraft.tropical_fish_spawn_egg": "Ovo Gerador de Peixe Tropical",
  "item.minecraft.turtle_helmet": "Casco de Tartaruga",
  "item.minecraft.turtle_scute": "Escama de Tartaruga",
  "item.minecraft.turtle_spawn_egg": "Ovo Gerador de Tartaruga",
  "item.minecraft.vex_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.vex_armor_trim_smithing_template.new": "Enfeite de Vex",
  "item.minecraft.vex_spawn_egg": "Ovo Gerador de Vex",
  "item.minecraft.villager_spawn_egg": "Ovo Gerador de Aldeão",
  "item.minecraft.vindicator_spawn_egg": "Ovo Gerador de Vingador",
  "item.minecraft.wandering_trader_spawn_egg": "Ovo Gerador de Vendedor Ambulante",
  "item.minecraft.ward_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.ward_armor_trim_smithing_template.new": "Enfeite das Profundezas",
  "item.minecraft.warden_spawn_egg": "Ovo Gerador de Defensor",
  "item.minecraft.warped_fungus_on_a_stick": "Vara com Fungo Distorcido",
  "item.minecraft.water_bucket": "Balde de Água",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "Enfeite de Navegador",
  "item.minecraft.wheat": "Trigo",
  "item.minecraft.wheat_seeds": "Sementes de Trigo",
  "item.minecraft.white_bundle": "Trouxa Branca",
  "item.minecraft.white_dye": "Corante Branco",
  "item.minecraft.white_harness": "Arreio Branco",
  "item.minecraft.wild_armor_trim_smithing_template": "Molde de Ferraria",
  "item.minecraft.wild_armor_trim_smithing_template.new": "Enfeite da Selva",
  "item.minecraft.wind_charge": "Projétil de Vento",
  "item.minecraft.witch_spawn_egg": "Ovo Gerador de Bruxa",
  "item.minecraft.wither_skeleton_spawn_egg": "Ovo Gerador de Esqueleto Wither",
  "item.minecraft.wither_spawn_egg": "Ovo Gerador do Wither",
  "item.minecraft.wolf_armor": "Armadura de Lobo",
  "item.minecraft.wolf_spawn_egg": "Ovo Gerador de Lobo",
  "item.minecraft.wooden_axe": "Machado de Madeira",
  "item.minecraft.wooden_hoe": "Enxada de Madeira",
  "item.minecraft.wooden_pickaxe": "Picareta de Madeira",
  "item.minecraft.wooden_shovel": "Pá de Madeira",
  "item.minecraft.wooden_spear": "Lança de Madeira",
  "item.minecraft.wooden_sword": "Espada de Madeira",
  "item.minecraft.writable_book": "Livro e Pena",
  "item.minecraft.written_book": "Livro Escrito",
  "item.minecraft.yellow_bundle": "Trouxa Amarela",
  "item.minecraft.yellow_dye": "Corante Amarelo",
  "item.minecraft.yellow_harness": "Arreio Amarelo",
  "item.minecraft.zoglin_spawn_egg": "Ovo Gerador de Zoglin",
  "item.minecraft.zombie_horse_spawn_egg": "Ovo Gerador de Cavalo-Zumbi",
  "item.minecraft.zombie_nautilus_spawn_egg": "Ovo Gerador de Náutilo-Zumbi",
  "item.minecraft.zombie_spawn_egg": "Ovo Gerador de Zumbi",
  "item.minecraft.zombie_villager_spawn_egg": "Ovo Gerador de Aldeão Zumbi",
  "item.minecraft.zombified_piglin_spawn_egg": "Ovo Gerador de Piglin-Zumbi"
}
export const pt_br = items; 
